import React from 'react';

export const Icons = {
  upArrow2: () => {
    return (
      <svg
        width='12'
        height='17'
        viewBox='0 0 12 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.46967 0.969669C5.76256 0.676776 6.23744 0.676776 6.53033 0.969669L11.3033 5.74264C11.5962 6.03553 11.5962 6.51041 11.3033 6.8033C11.0104 7.09619 10.5355 7.09619 10.2426 6.8033L6 2.56066L1.75736 6.8033C1.46447 7.09619 0.989592 7.09619 0.696699 6.8033C0.403805 6.51041 0.403805 6.03553 0.696699 5.74264L5.46967 0.969669ZM5.25 16.5L5.25 1.5L6.75 1.5L6.75 16.5L5.25 16.5Z'
          fill='white'
        />
      </svg>
    );
  },
  downArrow2: () => {
    return (
      <svg
        width='12'
        height='17'
        viewBox='0 0 12 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.46967 16.0303C5.76256 16.3232 6.23744 16.3232 6.53033 16.0303L11.3033 11.2574C11.5962 10.9645 11.5962 10.4896 11.3033 10.1967C11.0104 9.90381 10.5355 9.90381 10.2426 10.1967L6 14.4393L1.75736 10.1967C1.46447 9.90381 0.989592 9.90381 0.696699 10.1967C0.403805 10.4896 0.403805 10.9645 0.696699 11.2574L5.46967 16.0303ZM5.25 0.5L5.25 15.5L6.75 15.5L6.75 0.5L5.25 0.5Z'
          fill='white'
        />
      </svg>
    );
  },
  image: () => (
    <svg
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.4217 13.7537H1.57828C0.713981 13.7537 0 13.0397 0 12.1754V1.57829C0 0.713987 0.713981 0 1.57828 0H16.4217C17.286 0 18 0.713987 18 1.57829V12.1754C18 13.0397 17.286 13.7537 16.4217 13.7537ZM1.54071 1.01461C1.24009 1.01461 1.01461 1.24008 1.01461 1.54071V12.1378C1.01461 12.4384 1.24009 12.6639 1.54071 12.6639H16.3841C16.6848 12.6639 16.9102 12.4384 16.9102 12.1378V1.54071C16.9102 1.24008 16.6848 1.01461 16.3841 1.01461H1.54071Z'
        fill='white'
      />
      <path
        d='M11.6493 6.27619C10.4844 6.27619 9.58252 5.33673 9.58252 4.20938C9.58252 3.08204 10.522 2.14258 11.6493 2.14258C12.7767 2.14258 13.7161 3.08204 13.7161 4.20938C13.7161 5.33673 12.7767 6.27619 11.6493 6.27619ZM11.6493 3.08204C11.0481 3.08204 10.5596 3.57055 10.5596 4.1718C10.5596 4.77306 11.0481 5.26158 11.6493 5.26158C12.2506 5.26158 12.7391 4.77306 12.7391 4.1718C12.7391 3.57055 12.2506 3.08204 11.6493 3.08204Z'
        fill='white'
      />
      <path
        d='M14.4677 13.5659L5.78713 5.41141L0.826795 9.99596L0.150391 9.28197L5.78713 4.05859L15.1441 12.8519L14.4677 13.5659Z'
        fill='white'
      />
      <path
        d='M17.1732 10.8595L14.2797 8.52961L11.8747 10.5213L11.2358 9.73212L14.2797 7.25195L17.7745 10.1079L17.1732 10.8595Z'
        fill='white'
      />
    </svg>
  ),
  rightGreenArrow: () => (
    <svg
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 6.5L0.749999 12.9952L0.75 0.00480889L12 6.5Z'
        fill='#00C389'
      />
    </svg>
  ),
  copy2: () => (
    <svg
      width='9'
      height='12'
      viewBox='0 0 9 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.625 0.9375H5.15625V3.28125H7.5V2.8125H5.625V0.9375Z'
        fill='white'
      />
      <path
        d='M6.24902 0H1.40625V1.40625H0V11.25H7.03125V9.84375H8.4375V2.19727L6.24902 0ZM6.5625 10.7812H0.46875V1.875H1.40625V9.84375H6.5625V10.7812ZM7.96875 9.375H1.875V0.46875H6.05566L7.96875 2.39063V9.375Z'
        fill='white'
      />
    </svg>
  ),
  copy: () => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 11 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.28125 1.5625H6.6875V4.53125H9.65625V3.9375H7.28125V1.5625Z'
        fill='black'
        fillOpacity='0.5'
      />
      <path
        d='M8.07168 0.375H1.9375V2.15625H0.15625V14.625H9.0625V12.8438H10.8438V3.1582L8.07168 0.375ZM8.46875 14.0312H0.75V2.75H1.9375V12.8438H8.46875V14.0312ZM10.25 12.25H2.53125V0.96875H7.82676L10.25 3.40313V12.25Z'
        fill='black'
        fillOpacity='0.5'
      />
    </svg>
  ),
  search: () => {
    return (
      <svg
        className='w-4 h-4'
        aria-hidden='true'
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 20 20'
      >
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          d='m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z'
        />
      </svg>
    );
  },
  subject: () => {
    return (
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10.8327 13.3333H2.49935C2.27834 13.3333 2.06637 13.4211 1.91009 13.5774C1.75381 13.7337 1.66602 13.9457 1.66602 14.1667C1.66602 14.3877 1.75381 14.5996 1.91009 14.7559C2.06637 14.9122 2.27834 15 2.49935 15H10.8327C11.0537 15 11.2657 14.9122 11.4219 14.7559C11.5782 14.5996 11.666 14.3877 11.666 14.1667C11.666 13.9457 11.5782 13.7337 11.4219 13.5774C11.2657 13.4211 11.0537 13.3333 10.8327 13.3333ZM2.49935 6.66667H17.4993C17.7204 6.66667 17.9323 6.57887 18.0886 6.42259C18.2449 6.26631 18.3327 6.05435 18.3327 5.83333C18.3327 5.61232 18.2449 5.40036 18.0886 5.24408C17.9323 5.0878 17.7204 5 17.4993 5H2.49935C2.27834 5 2.06637 5.0878 1.91009 5.24408C1.75381 5.40036 1.66602 5.61232 1.66602 5.83333C1.66602 6.05435 1.75381 6.26631 1.91009 6.42259C2.06637 6.57887 2.27834 6.66667 2.49935 6.66667ZM17.4993 9.16667H2.49935C2.27834 9.16667 2.06637 9.25446 1.91009 9.41074C1.75381 9.56702 1.66602 9.77899 1.66602 10C1.66602 10.221 1.75381 10.433 1.91009 10.5893C2.06637 10.7455 2.27834 10.8333 2.49935 10.8333H17.4993C17.7204 10.8333 17.9323 10.7455 18.0886 10.5893C18.2449 10.433 18.3327 10.221 18.3327 10C18.3327 9.77899 18.2449 9.56702 18.0886 9.41074C17.9323 9.25446 17.7204 9.16667 17.4993 9.16667Z'
          fill='#009379'
        />
      </svg>
    );
  },
  noCodeNeeded: () => {
    return (
      <svg
        width='82'
        height='82'
        viewBox='0 0 82 82'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z'
          fill='#F8D57E'
          fillOpacity='0.2'
        />
        <path
          opacity='0.2'
          d='M36.8 52.5499L29.45 45.2L26.218 54.1085C26.1286 54.3423 26.1089 54.5969 26.1611 54.8417C26.2133 55.0864 26.3352 55.3108 26.5122 55.4878C26.6891 55.6648 26.9135 55.7867 27.1583 55.8389C27.4031 55.8911 27.6577 55.8713 27.8914 55.782L36.8 52.5499Z'
          fill='#F8D57E'
        />
        <path
          opacity='0.2'
          d='M52.6207 44.8341L52.6209 44.8343C52.7706 44.9826 52.8802 45.1664 52.9398 45.3684C52.9994 45.5705 53.007 45.7844 52.9617 45.9902C52.9165 46.1959 52.82 46.387 52.6812 46.5455C52.5424 46.704 52.3658 46.8248 52.1678 46.8968L45.4787 49.3277L32.6724 36.5215L35.1034 29.8323C35.1753 29.6343 35.2962 29.4577 35.4547 29.3189C35.6132 29.1801 35.8042 29.0836 36.01 29.0384C36.2157 28.9932 36.4296 29.0007 36.6317 29.0603C36.8338 29.1199 37.0175 29.2296 37.1659 29.3792L37.1661 29.3794L52.6207 44.8341Z'
          fill='#F8D57E'
          stroke='#F8D57E'
          strokeWidth='0.125'
        />
        <path
          d='M26.218 54.1086L35.0446 29.811C35.1201 29.6031 35.247 29.4176 35.4134 29.2719C35.5799 29.1261 35.7804 29.0248 35.9965 28.9773C36.2126 28.9299 36.4371 28.9378 36.6493 29.0004C36.8615 29.0629 37.0544 29.1781 37.2102 29.3352L52.6649 44.7899C52.822 44.9456 52.9372 45.1386 52.9997 45.3508C53.0623 45.563 53.0702 45.7875 53.0227 46.0036C52.9753 46.2196 52.8739 46.4202 52.7282 46.5866C52.5825 46.7531 52.397 46.8799 52.1891 46.9555L27.8914 55.7821C27.6577 55.8714 27.4031 55.8912 27.1583 55.839C26.9135 55.7868 26.6891 55.6648 26.5122 55.4879C26.3352 55.3109 26.2133 55.0865 26.1611 54.8418C26.1089 54.597 26.1286 54.3424 26.218 54.1086V54.1086Z'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M47.5625 31.8125C47.5625 31.8125 47.5625 27.875 51.5 27.875C55.4375 27.875 55.4375 23.9375 55.4375 23.9375'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M36.8 52.5499L29.45 45.2'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M43.625 22.625V26.5625'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M55.4375 38.375L58.0625 41'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M55.4375 33.125L59.375 31.8125'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M32.6001 36.5375L45.4626 49.4'
          stroke='#F8D57E'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  },
  customizedDesign: () => {
    return (
      <svg
        width='82'
        height='82'
        viewBox='0 0 82 82'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z'
          fill='#009379'
          fillOpacity='0.2'
        />
        <path
          opacity='0.2'
          d='M54.125 26.5625H48.875C48.1501 26.5625 47.5625 27.1501 47.5625 27.875V33.125C47.5625 33.8499 48.1501 34.4375 48.875 34.4375H54.125C54.8499 34.4375 55.4375 33.8499 55.4375 33.125V27.875C55.4375 27.1501 54.8499 26.5625 54.125 26.5625Z'
          fill='#009379'
        />
        <path
          opacity='0.2'
          d='M27.875 26.625H33.125C33.8154 26.625 34.375 27.1846 34.375 27.875V33.125C34.375 33.8154 33.8154 34.375 33.125 34.375H27.875C27.1846 34.375 26.625 33.8154 26.625 33.125V27.875C26.625 27.1846 27.1846 26.625 27.875 26.625Z'
          fill='#009379'
          stroke='#009379'
          strokeWidth='0.125'
        />
        <path
          opacity='0.2'
          d='M48.875 47.625H54.125C54.8154 47.625 55.375 48.1846 55.375 48.875V54.125C55.375 54.8154 54.8154 55.375 54.125 55.375H48.875C48.1846 55.375 47.625 54.8154 47.625 54.125V48.875C47.625 48.1846 48.1846 47.625 48.875 47.625Z'
          fill='#009379'
          stroke='#009379'
          strokeWidth='0.125'
        />
        <path
          opacity='0.2'
          d='M27.875 47.625H33.125C33.8154 47.625 34.375 48.1846 34.375 48.875V54.125C34.375 54.8154 33.8154 55.375 33.125 55.375H27.875C27.1846 55.375 26.625 54.8154 26.625 54.125V48.875C26.625 48.1846 27.1846 47.625 27.875 47.625Z'
          fill='#009379'
          stroke='#009379'
          strokeWidth='0.125'
        />
        <path
          d='M54.125 26.5625H48.875C48.1501 26.5625 47.5625 27.1501 47.5625 27.875V33.125C47.5625 33.8499 48.1501 34.4375 48.875 34.4375H54.125C54.8499 34.4375 55.4375 33.8499 55.4375 33.125V27.875C55.4375 27.1501 54.8499 26.5625 54.125 26.5625Z'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33.125 26.5625H27.875C27.1501 26.5625 26.5625 27.1501 26.5625 27.875V33.125C26.5625 33.8499 27.1501 34.4375 27.875 34.4375H33.125C33.8499 34.4375 34.4375 33.8499 34.4375 33.125V27.875C34.4375 27.1501 33.8499 26.5625 33.125 26.5625Z'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M54.125 47.5625H48.875C48.1501 47.5625 47.5625 48.1501 47.5625 48.875V54.125C47.5625 54.8499 48.1501 55.4375 48.875 55.4375H54.125C54.8499 55.4375 55.4375 54.8499 55.4375 54.125V48.875C55.4375 48.1501 54.8499 47.5625 54.125 47.5625Z'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33.125 47.5625H27.875C27.1501 47.5625 26.5625 48.1501 26.5625 48.875V54.125C26.5625 54.8499 27.1501 55.4375 27.875 55.4375H33.125C33.8499 55.4375 34.4375 54.8499 34.4375 54.125V48.875C34.4375 48.1501 33.8499 47.5625 33.125 47.5625Z'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M30.5 47.5625V34.4375'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M47.5625 51.5H34.4375'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M51.5 34.4375V47.5625'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M34.4375 30.5H47.5625'
          stroke='#009379'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  },
  fastBuilding: () => {
    return (
      <svg
        width='82'
        height='82'
        viewBox='0 0 82 82'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z'
          fill='#FF6250'
          fillOpacity='0.2'
        />
        <path
          opacity='0.2'
          d='M31.4351 55.8148C31.313 55.9389 31.1674 56.0373 31.0069 56.1046C30.8463 56.1718 30.674 56.2064 30.5 56.2064C30.3259 56.2064 30.1536 56.1718 29.9931 56.1046C29.8325 56.0373 29.6869 55.9389 29.5648 55.8148L26.1851 52.4352C26.0611 52.313 25.9626 52.1675 25.8954 52.0069C25.8282 51.8464 25.7936 51.6741 25.7936 51.5C25.7936 51.3259 25.8282 51.1536 25.8954 50.9931C25.9626 50.8325 26.0611 50.687 26.1851 50.5648L43.625 33.125L48.875 38.375L31.4351 55.8148Z'
          fill='#FF6250'
        />
        <path
          d='M55.4375 41V48.875'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M51.5 44.9375H59.375'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M33.7812 26.5625V33.125'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M30.5 29.8438H37.0625'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M47.5625 50.1875V55.4375'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M44.9375 52.8125H50.1875'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M50.5855 26.174L26.1887 50.5708C25.6761 51.0834 25.6761 51.9144 26.1887 52.427L29.582 55.8203C30.0945 56.3328 30.9256 56.3328 31.4381 55.8203L55.835 31.4234C56.3475 30.9109 56.3475 30.0798 55.835 29.5673L52.4417 26.174C51.9291 25.6614 51.0981 25.6614 50.5855 26.174Z'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M43.625 33.125L48.875 38.375'
          stroke='#FF6250'
          strokeWidth='2.375'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  },
  hubSpotLogo: () => {
    return (
      <svg
        width='90'
        height='27'
        viewBox='0 0 90 27'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_943_7980)'>
          <path
            d='M9.74652 4.55725V11.8106H3.13764V4.55725H0V21.8716H3.13764V14.8538H9.74652V21.8716H12.8842V4.55725H9.74652Z'
            fill='#33475B'
          />
          <path
            d='M22.9258 16.2747C22.9258 16.9686 22.6523 17.6341 22.1655 18.1248C21.6787 18.6154 21.0185 18.8911 20.33 18.8911C19.6416 18.8911 18.9814 18.6154 18.4946 18.1248C18.0078 17.6341 17.7343 16.9686 17.7343 16.2747V8.8587H14.7581V16.2747C14.7581 17.7628 15.3445 19.1899 16.3885 20.2422C17.4324 21.2944 18.8483 21.8855 20.3246 21.8855C21.801 21.8855 23.2169 21.2944 24.2608 20.2422C25.3047 19.1899 25.8912 17.7628 25.8912 16.2747V8.8587H22.9258V16.2747Z'
            fill='#33475B'
          />
          <path
            d='M44.9771 9.62263C44.9771 8.10255 45.9748 7.62065 47.0679 7.62065C47.9487 7.62065 49.1125 8.29624 49.8734 9.11594L51.8228 6.80096C50.8496 5.47457 48.8757 4.55725 47.26 4.55725C44.0317 4.55725 41.6965 6.46316 41.6965 9.62263C41.6965 15.4845 48.805 13.625 48.805 16.9054C48.805 17.9172 47.8304 18.8113 46.7143 18.8113C44.9541 18.8113 44.3837 17.9436 43.5751 17.0262L41.4121 19.2932C42.7957 21.0054 44.5021 21.8747 46.5467 21.8747C49.6136 21.8747 52.081 19.9455 52.081 16.9302C52.081 10.4222 44.9725 12.4443 44.9725 9.62263'
            fill='#33475B'
          />
          <path
            d='M88.953 19.1057C87.1944 19.1057 86.6947 18.3387 86.6947 17.1642V11.9655H89.4281V9.33135H86.6947V5.85577L83.677 7.2209V17.8103C83.677 20.5189 85.531 21.884 88.0737 21.884C88.4725 21.8913 88.871 21.8592 89.2636 21.7879L89.9999 19.0561C89.6679 19.0794 89.2866 19.1026 88.953 19.1026'
            fill='#33475B'
          />
          <path
            d='M34.2543 8.94549C32.7801 8.94549 31.7516 9.37626 30.757 10.3602V4.66107H27.7761V15.2241C27.7761 19.1785 30.6125 21.8871 33.7993 21.8871C37.3351 21.8871 40.4451 19.1305 40.4451 15.4178C40.4451 11.7517 37.5826 8.94704 34.2543 8.94704V8.94549ZM34.2359 18.864C33.567 18.864 32.9131 18.664 32.3569 18.2895C31.8007 17.9149 31.3672 17.3825 31.1113 16.7596C30.8553 16.1367 30.7883 15.4512 30.9188 14.79C31.0493 14.1287 31.3714 13.5213 31.8444 13.0445C32.3174 12.5678 32.92 12.2431 33.5761 12.1116C34.2321 11.9801 34.9121 12.0476 35.5301 12.3056C36.1481 12.5636 36.6763 13.0005 37.048 13.5611C37.4196 14.1217 37.618 14.7808 37.618 15.455C37.618 16.3591 37.2616 17.2262 36.6274 17.8655C35.9931 18.5048 35.1329 18.864 34.2359 18.864Z'
            fill='#33475B'
          />
          <path
            d='M66.6206 15.2598C66.6206 11.541 63.5168 8.79059 59.9748 8.79059C56.788 8.79059 53.9517 11.4991 53.9517 15.4535V26.0228H56.9325V20.3159C57.9256 21.2983 58.9556 21.7306 60.4283 21.7306C63.7566 21.7306 66.619 18.9275 66.619 15.2598H66.6206ZM63.7981 15.2226C63.7981 15.8969 63.5997 16.556 63.2281 17.1165C62.8565 17.6771 62.3283 18.1141 61.7103 18.3721C61.0923 18.6301 60.4123 18.6976 59.7562 18.5661C59.1002 18.4345 58.4975 18.1099 58.0245 17.6331C57.5515 17.1564 57.2294 16.549 57.0989 15.8877C56.9684 15.2264 57.0354 14.541 57.2914 13.9181C57.5474 13.2952 57.9809 12.7628 58.537 12.3882C59.0932 12.0136 59.7471 11.8137 60.416 11.8137C61.313 11.8137 62.1732 12.1729 62.8075 12.8122C63.4418 13.4515 63.7981 14.3185 63.7981 15.2226Z'
            fill='#33475B'
          />
          <path
            d='M76.2504 8.64491V5.62644C76.6462 5.44006 76.9813 5.1442 77.2167 4.77332C77.4521 4.40244 77.5782 3.97178 77.5802 3.53149V3.46176C77.5802 2.84533 77.3372 2.25414 76.9048 1.81825C76.4723 1.38236 75.8858 1.13748 75.2742 1.13748H75.205C74.5935 1.13748 74.0069 1.38236 73.5745 1.81825C73.142 2.25414 72.8991 2.84533 72.8991 3.46176V3.53149C72.9011 3.97178 73.0272 4.40244 73.2626 4.77332C73.498 5.1442 73.8331 5.44006 74.2289 5.62644V8.64491C73.0914 8.8203 72.0201 9.29552 71.1235 10.0224L62.9112 3.57488C62.9693 3.36226 63.0003 3.14305 63.0035 2.92253C63.0044 2.40454 62.8529 1.89791 62.5681 1.46672C62.2833 1.03554 61.878 0.699171 61.4035 0.500165C60.9291 0.301159 60.4067 0.248456 59.9025 0.348722C59.3983 0.448989 58.935 0.697719 58.571 1.06345C58.2071 1.42919 57.959 1.89549 57.858 2.40339C57.757 2.91129 57.8078 3.43796 58.0038 3.91679C58.1998 4.39562 58.5324 4.80509 58.9593 5.09341C59.3862 5.38173 59.8884 5.53596 60.4023 5.53657C60.8517 5.53455 61.2927 5.4138 61.6814 5.18638L69.7691 11.5286C69.0424 12.6349 68.6633 13.9362 68.6811 15.2629C68.6989 16.5897 69.1129 17.8802 69.8691 18.9663L67.4094 21.4455C67.2105 21.3815 67.0032 21.3475 66.7945 21.3448C66.3726 21.3451 65.9602 21.4714 65.6096 21.7079C65.2589 21.9443 64.9857 22.2802 64.8243 22.6732C64.663 23.0661 64.6209 23.4984 64.7033 23.9155C64.7857 24.3325 64.9889 24.7156 65.2872 25.0163C65.5855 25.317 65.9656 25.5218 66.3793 25.6048C66.7931 25.6879 67.222 25.6454 67.6118 25.4828C68.0017 25.3202 68.3349 25.0448 68.5695 24.6914C68.8041 24.3379 68.9295 23.9223 68.9298 23.4971C68.9271 23.2866 68.8935 23.0777 68.8298 22.8772L71.2634 20.4244C72.0569 21.0399 72.9797 21.4641 73.961 21.6647C74.9423 21.8652 75.9562 21.8367 76.9249 21.5814C77.8936 21.3261 78.7915 20.8506 79.5497 20.1915C80.308 19.5324 80.9066 18.7071 81.2996 17.7789C81.6925 16.8506 81.8695 15.844 81.817 14.8362C81.7645 13.8283 81.4838 12.846 80.9964 11.9643C80.509 11.0827 79.828 10.3252 79.0053 9.74983C78.1827 9.17447 77.2403 8.79651 76.2504 8.64491ZM75.2419 18.5711C74.5763 18.5705 73.9257 18.371 73.3725 17.9978C72.8193 17.6247 72.3882 17.0945 72.1339 16.4745C71.8795 15.8545 71.8131 15.1723 71.9433 14.5143C72.0734 13.8563 72.3941 13.2519 72.8649 12.7776C73.3358 12.3033 73.9355 11.9803 74.5884 11.8494C75.2413 11.7185 75.918 11.7857 76.533 12.0424C77.1481 12.2991 77.6738 12.7338 78.0438 13.2916C78.4138 13.8494 78.6114 14.5052 78.6117 15.1761C78.6117 16.0761 78.257 16.9393 77.6256 17.5757C76.9943 18.2121 76.1379 18.5696 75.245 18.5696'
            fill='#FF7A59'
          />
        </g>
        <defs>
          <clipPath id='clip0_943_7980'>
            <rect
              width='90'
              height='25.7143'
              fill='white'
              transform='translate(0 0.300781)'
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  fedExLogo: () => {
    return (
      <svg
        width='90'
        height='28'
        viewBox='0 0 90 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_943_7979)'>
          <path
            d='M66.9275 26.8498L74.4331 18.5369L66.9275 10.2228H74.8467L78.5641 14.2613L82.1437 10.2228H89.7867L82.3167 18.5026L89.8892 26.8498H81.9375L78.2538 22.7782L74.6049 26.8498H66.9275Z'
            fill='#FF6600'
          />
          <path
            d='M66.9274 6.49568H58.4267V10.2228H66.9274V15.84H58.4267V20.9958H66.9274V26.8498H52.1787V0.657898H66.9274V6.49568Z'
            fill='#FF6600'
          />
          <path
            d='M45.9571 0.657898V11.3769H45.8887C44.5113 9.8163 42.7903 9.27398 40.7935 9.27398C36.7032 9.27398 33.622 12.0149 32.5405 15.6387C31.3071 11.6457 28.1262 9.19915 23.4094 9.19915C19.5789 9.19915 16.5541 10.894 14.9756 13.6557V10.2232H7.05796V6.49645H15.6983V0.657898H0V26.8502H7.05796V15.84H14.0928C13.8831 16.6488 13.7712 17.5148 13.7712 18.4285C13.7712 23.8922 18.0055 27.7258 23.4094 27.7258C27.9536 27.7258 30.9483 25.6229 32.5323 21.7889H26.4839C25.6657 22.9406 25.045 23.2827 23.4094 23.2827C21.5127 23.2827 19.8775 21.6516 19.8775 19.718H32.1934C32.7275 24.0576 36.1569 27.8002 40.8631 27.8002C42.8932 27.8002 44.7519 26.8159 45.8887 25.1538H45.9571V26.8494H52.1789V0.657898H45.9571ZM20.0739 15.9183C20.4664 14.2547 21.7753 13.1674 23.4094 13.1674C25.2082 13.1674 26.4506 14.2212 26.7773 15.9183C26.9151 15.9183 20.0739 15.9183 20.0739 15.9183ZM42.1814 22.8619C39.888 22.8619 38.4629 20.7555 38.4629 18.5562C38.4629 16.2053 39.7025 13.9446 42.1814 13.9446C44.7519 13.9446 45.776 16.2053 45.776 18.5562C45.7756 20.7856 44.6905 22.8619 42.1814 22.8619Z'
            fill='#652C8F'
          />
        </g>
        <defs>
          <clipPath id='clip0_943_7979'>
            <rect
              width='90'
              height='27'
              fill='white'
              transform='translate(0 0.657898)'
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  microsoftLogo: () => {
    return (
      <svg
        width='90'
        height='20'
        viewBox='0 0 90 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_943_7978)'>
          <path
            d='M31.7682 11.615L31.2318 13.1316H31.1871C31.0977 12.7897 30.9338 12.2693 30.6656 11.6448L27.7897 4.43358H24.9735V15.9269H26.8361V8.83464C26.8361 8.38859 26.8361 7.88306 26.8212 7.25858C26.8063 6.94635 26.7765 6.70845 26.7616 6.53003H26.8063C26.8957 6.97608 27 7.30319 27.0745 7.51135L30.5315 15.8972H31.8427L35.2699 7.43701C35.3444 7.24372 35.4189 6.85714 35.4934 6.53003H35.5381C35.4934 7.37753 35.4636 8.13583 35.4487 8.59675V15.8823H37.4305V4.40384H34.7185L31.7682 11.615ZM39.3079 7.64516H41.245V15.8823H39.3079V7.64516ZM40.2914 4.16594C39.9636 4.16594 39.6954 4.28489 39.4719 4.49305C39.2483 4.70121 39.1291 4.96884 39.1291 5.29595C39.1291 5.60818 39.2483 5.87582 39.4719 6.08398C39.6954 6.29213 39.9636 6.39621 40.2914 6.39621C40.6192 6.39621 40.9023 6.27727 41.1109 6.08398C41.3344 5.87582 41.4536 5.60818 41.4536 5.29595C41.4536 4.98371 41.3344 4.71608 41.1109 4.49305C40.9172 4.28489 40.6341 4.16594 40.2914 4.16594ZM48.1142 7.57082C47.7566 7.49648 47.3841 7.45187 47.0265 7.45187C46.1474 7.45187 45.3427 7.64517 44.6722 8.03175C44.0017 8.41833 43.4652 8.95359 43.1225 9.62267C42.7649 10.3066 42.5861 11.0947 42.5861 12.0016C42.5861 12.7897 42.7649 13.4885 43.1076 14.1278C43.4503 14.7523 43.9272 15.2578 44.5679 15.5998C45.1788 15.9418 45.894 16.1202 46.6987 16.1202C47.6225 16.1202 48.4123 15.9269 49.0381 15.5701L49.053 15.5552V13.771L48.9785 13.8305C48.6954 14.0386 48.3675 14.217 48.0397 14.3211C47.697 14.4401 47.3841 14.4995 47.1159 14.4995C46.3411 14.4995 45.7301 14.2765 45.298 13.7858C44.851 13.3101 44.6275 12.6558 44.6275 11.8381C44.6275 10.9906 44.851 10.3215 45.3129 9.83083C45.7748 9.34017 46.3858 9.08741 47.1308 9.08741C47.7566 9.08741 48.3974 9.29557 48.9785 9.71188L49.053 9.77136V7.88306L49.0381 7.86819C48.7848 7.76411 48.5017 7.64516 48.1142 7.57082ZM54.5066 7.51135C54.0298 7.51135 53.5828 7.66003 53.1954 7.97227C52.8675 8.2399 52.644 8.62648 52.4503 9.08741H52.4354V7.64516H50.4983V15.8823H52.4354V11.6745C52.4354 10.9608 52.5844 10.3661 52.9123 9.93491C53.2401 9.48886 53.6573 9.26583 54.1639 9.26583C54.3427 9.26583 54.5215 9.31043 54.745 9.34017C54.9536 9.39965 55.1026 9.45912 55.207 9.53346L55.2815 9.59294V7.66003L55.2368 7.64516C55.1026 7.55595 54.8344 7.51135 54.5066 7.51135ZM59.7815 7.46674C58.4255 7.46674 57.3377 7.86819 56.5778 8.65622C55.803 9.44425 55.4305 10.5296 55.4305 11.8975C55.4305 13.1762 55.8179 14.217 56.5629 14.9753C57.3079 15.7187 58.3212 16.1053 59.5877 16.1053C60.9139 16.1053 61.9719 15.7039 62.7318 14.901C63.5066 14.0981 63.8791 13.0276 63.8791 11.7043C63.8791 10.3958 63.5215 9.35504 62.7914 8.59675C62.0911 7.83846 61.0629 7.46674 59.7815 7.46674ZM61.3311 13.8007C60.9735 14.2616 60.4073 14.4847 59.707 14.4847C59.0066 14.4847 58.4404 14.2616 58.0381 13.771C57.6358 13.3101 57.4421 12.641 57.4421 11.7935C57.4421 10.9162 57.6507 10.2471 58.0381 9.77136C58.4404 9.29557 58.9917 9.05767 59.6921 9.05767C60.3775 9.05767 60.9139 9.2807 61.3013 9.74162C61.6887 10.2025 61.8974 10.8716 61.8974 11.7489C61.8675 12.641 61.7036 13.3398 61.3311 13.8007ZM68.2003 11.0649C67.5894 10.8122 67.202 10.6189 67.0232 10.4553C66.8742 10.3066 66.7997 10.0985 66.7997 9.83083C66.7997 9.6078 66.8891 9.38478 67.1126 9.23609C67.3361 9.08741 67.5894 9.01306 67.9619 9.01306C68.2897 9.01306 68.6324 9.07254 68.9603 9.16175C69.2881 9.25096 69.5861 9.38478 69.8245 9.5632L69.899 9.62267V7.80872L69.8543 7.79385C69.6308 7.70464 69.3328 7.61543 68.9752 7.54109C68.6175 7.48161 68.2897 7.45187 68.0215 7.45187C67.0977 7.45187 66.3377 7.6749 65.7417 8.16556C65.1457 8.62648 64.8626 9.25096 64.8626 9.97952C64.8626 10.3661 64.9222 10.7081 65.0563 10.9906C65.1904 11.2731 65.3841 11.5407 65.6523 11.7637C65.9205 11.9719 66.3079 12.2098 66.8444 12.4328C67.2914 12.6261 67.6341 12.7748 67.8427 12.8937C68.0513 13.0127 68.1854 13.1465 68.2897 13.2506C68.3642 13.3695 68.4089 13.5182 68.4089 13.7115C68.4089 14.2616 67.9917 14.5293 67.1424 14.5293C66.8146 14.5293 66.4719 14.4698 66.0695 14.336C65.6672 14.2022 65.2947 14.0089 64.9818 13.7858L64.9073 13.7264V15.6147L64.952 15.6295C65.2351 15.7634 65.5778 15.8526 65.995 15.9566C66.4123 16.031 66.7848 16.0905 67.1126 16.0905C68.1109 16.0905 68.9305 15.8674 69.5116 15.3768C70.1076 14.901 70.4205 14.2914 70.4205 13.5033C70.4205 12.9532 70.2715 12.4626 69.9437 12.0908C69.5116 11.734 68.9752 11.3623 68.2003 11.0649ZM75.5315 7.46674C74.1755 7.46674 73.0877 7.86819 72.3278 8.65622C71.5679 9.44425 71.1805 10.5296 71.1805 11.8975C71.1805 13.1762 71.5679 14.217 72.3129 14.9753C73.0579 15.7187 74.0712 16.1053 75.3377 16.1053C76.6639 16.1053 77.7219 15.7039 78.4818 14.901C79.2566 14.0981 79.6291 13.0276 79.6291 11.7043C79.6291 10.3958 79.2715 9.35504 78.5414 8.59675C77.8411 7.83846 76.8129 7.46674 75.5315 7.46674ZM77.0662 13.8007C76.7086 14.2616 76.1424 14.4847 75.4421 14.4847C74.7268 14.4847 74.1755 14.2616 73.7732 13.771C73.3709 13.3101 73.1772 12.641 73.1772 11.7935C73.1772 10.9162 73.3858 10.2471 73.7732 9.77136C74.1755 9.29557 74.7268 9.05767 75.4272 9.05767C76.0977 9.05767 76.649 9.2807 77.0364 9.74162C77.4238 10.2025 77.6325 10.8716 77.6325 11.7489C77.6325 12.641 77.4387 13.3398 77.0662 13.8007ZM89.9851 9.23609V7.64516H88.0331V5.20674L87.9735 5.2216L86.1258 5.77174L86.0811 5.78661V7.64516H83.1606V6.60437C83.1606 6.12858 83.2798 5.75687 83.4884 5.51897C83.697 5.28108 84.0099 5.16213 84.3974 5.16213C84.6656 5.16213 84.9487 5.2216 85.2616 5.35542L85.3361 5.40003V3.71989L85.2914 3.70502C85.0232 3.61581 84.6656 3.55634 84.2036 3.55634C83.6225 3.55634 83.1159 3.69015 82.654 3.91318C82.1921 4.16594 81.8493 4.50792 81.596 4.96884C81.3427 5.41489 81.2086 5.92042 81.2086 6.50029V7.64516H79.8527V9.22122H81.2086V15.8823H83.1606V9.23609H86.0811V13.4736C86.0811 15.2132 86.9007 16.0905 88.5397 16.0905C88.8079 16.0905 89.0911 16.0459 89.3593 16.0012C89.6424 15.9418 89.851 15.8674 89.9702 15.808L89.9851 15.7931V14.2022L89.9106 14.2616C89.7914 14.336 89.6871 14.3955 89.5083 14.4401C89.3593 14.4847 89.2252 14.4995 89.1209 14.4995C88.7334 14.4995 88.4652 14.4103 88.2715 14.1873C88.0927 13.9791 88.0033 13.6372 88.0033 13.1316V9.23609H89.9851Z'
            fill='#737373'
          />
          <path d='M0 0.567749H9.13411V9.68212H0V0.567749Z' fill='#F25022' />
          <path
            d='M10.0876 0.567749H19.2218V9.68212H10.0876V0.567749Z'
            fill='#C8FCF1'
          />
          <path d='M0 10.6337H9.13411V19.7481H0V10.6337Z' fill='#00A4EF' />
          <path
            d='M10.0876 10.6337H19.2218V19.7481H10.0876V10.6337Z'
            fill='#FFDA55'
          />
        </g>
        <defs>
          <clipPath id='clip0_943_7978'>
            <rect
              width='90'
              height='19.1803'
              fill='white'
              transform='translate(0 0.567749)'
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  amazonLogo: () => {
    return (
      <svg
        width='90'
        height='29'
        viewBox='0 0 90 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_943_7977)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M55.8342 22.0438C50.6041 26.0181 43.0235 28.1385 36.4967 28.1385C27.3451 28.1385 19.1063 24.6489 12.8733 18.845C12.3836 18.3886 12.8224 17.7666 13.4101 18.1221C20.1366 22.1569 28.4538 24.5843 37.0452 24.5843C42.8394 24.5843 49.2134 23.3484 55.0742 20.7837C55.9595 20.3959 56.7 21.3814 55.8342 22.0438Z'
            fill='#FFA736'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M58.0087 19.4791C57.3427 18.5987 53.5896 19.0631 51.905 19.2691C51.3918 19.3337 51.3135 18.8733 51.7758 18.5421C54.7649 16.3732 59.6698 16.9993 60.2418 17.7263C60.8137 18.4573 60.0929 23.5261 57.2839 25.9454C56.853 26.317 56.4417 26.1191 56.6336 25.6263C57.2644 24.0027 58.6786 20.3637 58.0087 19.4791Z'
            fill='#FFA736'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M52.0225 3.23072V1.12243C52.0225 0.803355 52.2576 0.589294 52.5396 0.589294H61.6952C61.989 0.589294 62.2241 0.807394 62.2241 1.12243V2.9278C62.2201 3.23072 61.9733 3.62653 61.5345 4.25255L56.7903 11.2358C58.5532 11.1913 60.4141 11.462 62.0125 12.3909C62.3729 12.6009 62.4709 12.9079 62.4983 13.2108V15.4604C62.4983 15.7674 62.1692 16.1269 61.8245 15.9411C59.0077 14.4184 55.2663 14.2528 52.1518 15.9572C51.8345 16.1349 51.5015 15.7795 51.5015 15.4726V13.336C51.5015 12.9927 51.5054 12.407 51.8384 11.886L57.3348 3.75981H52.5514C52.2576 3.75981 52.0225 3.54575 52.0225 3.23072Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.6245 16.3853H15.8391C15.5727 16.3651 15.3611 16.1591 15.3416 15.8966V1.15875C15.3416 0.863915 15.5805 0.629659 15.8783 0.629659H18.4757C18.746 0.641767 18.9615 0.855835 18.981 1.1224V3.04895H19.032C19.7097 1.18702 20.983 0.318665 22.6989 0.318665C24.4422 0.318665 25.5313 1.18702 26.3149 3.04895C26.9887 1.18702 28.5205 0.318665 30.162 0.318665C31.3295 0.318665 32.6066 0.815446 33.3862 1.93018C34.2677 3.17011 34.0875 4.97145 34.0875 6.55065L34.0836 15.8522C34.0836 16.147 33.8446 16.3853 33.5468 16.3853H30.7653C30.4872 16.3651 30.2639 16.1349 30.2639 15.8522V8.04099C30.2639 7.41901 30.3187 5.86808 30.1855 5.2784C29.9779 4.28888 29.355 4.0102 28.5479 4.0102C27.8741 4.0102 27.1689 4.47467 26.8829 5.21782C26.5969 5.96097 26.6244 7.20494 26.6244 8.04099V15.8522C26.6244 16.147 26.3854 16.3853 26.0876 16.3853H23.3061C23.0241 16.3651 22.8047 16.1349 22.8047 15.8522L22.8007 8.04099C22.8007 6.39717 23.0632 3.97789 21.0848 3.97789C19.0829 3.97789 19.1613 6.33659 19.1613 8.04099V15.8522C19.1613 16.147 18.9223 16.3853 18.6245 16.3853'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M70.1061 0.318665C74.2393 0.318665 76.4762 3.97789 76.4762 8.63067C76.4762 13.1259 74.0042 16.6923 70.1061 16.6923C66.0474 16.6923 63.8379 13.033 63.8379 8.47316C63.8379 3.88499 66.0749 0.318665 70.1061 0.318665ZM70.1296 3.32763C68.0768 3.32763 67.9475 6.21138 67.9475 8.00869C67.9475 9.81003 67.9201 13.655 70.1061 13.655C72.2648 13.655 72.3666 10.5532 72.3666 8.66298C72.3666 7.41901 72.3157 5.9327 71.9513 4.75335C71.6379 3.72748 71.015 3.32763 70.1296 3.32763Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M81.8357 16.3853H79.062C78.7839 16.3651 78.5606 16.1349 78.5606 15.8522L78.5566 1.11028C78.5801 0.839679 78.8113 0.629659 79.0934 0.629659H81.6751C81.918 0.641767 82.1178 0.811408 82.1726 1.04162V3.29532H82.2236C83.0032 1.27992 84.0962 0.318665 86.0197 0.318665C87.2695 0.318665 88.4879 0.783136 89.2714 2.05538C90.0001 3.23473 90.0001 5.21782 90.0001 6.64354V15.9208C89.9687 16.1793 89.7376 16.3853 89.4634 16.3853H86.6701C86.4154 16.3651 86.2039 16.1713 86.1765 15.9208V7.91579C86.1765 6.30428 86.3567 3.94557 84.4331 3.94557C83.7553 3.94557 83.1324 4.41409 82.8229 5.12493C82.4312 6.0256 82.3803 6.92223 82.3803 7.91579V15.8522C82.3763 16.147 82.1334 16.3853 81.8357 16.3853'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M44.7238 9.34556C44.7238 10.4643 44.7512 11.3973 44.2028 12.3909C43.7601 13.1987 43.0549 13.6954 42.2753 13.6954C41.2058 13.6954 40.579 12.8553 40.579 11.6154C40.579 9.16785 42.7062 8.72357 44.7238 8.72357V9.34556ZM47.5328 16.3449C47.3486 16.5146 47.0822 16.5267 46.8746 16.4136C45.95 15.622 45.7816 15.2544 45.2762 14.4992C43.7483 16.1066 42.6631 16.5873 40.6847 16.5873C38.3381 16.5873 36.5164 15.0969 36.5164 12.1122C36.5164 9.78176 37.7387 8.19448 39.4859 7.41902C40.9981 6.7324 43.1098 6.61124 44.7238 6.42141V6.04984C44.7238 5.36726 44.7748 4.55949 44.383 3.96982C44.0461 3.44072 43.3957 3.22262 42.8198 3.22262C41.7582 3.22262 40.814 3.78402 40.5829 4.94722C40.5359 5.20571 40.3517 5.46016 40.0971 5.47228L37.3978 5.1734C37.1706 5.12089 36.916 4.93106 36.9826 4.57161C37.6015 1.19511 40.5633 0.177307 43.2116 0.177307C44.5671 0.177307 46.3379 0.548885 47.4074 1.60707C48.7629 2.91163 48.6336 4.65238 48.6336 6.54662V11.0217C48.6336 12.3666 49.1743 12.9563 49.6836 13.6833C49.8599 13.9418 49.899 14.2528 49.6718 14.4467C49.1037 14.9354 48.093 15.8441 47.5367 16.353L47.5328 16.3449'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.20746 9.3458C8.20746 10.4646 8.23488 11.3975 7.68642 12.3911C7.24372 13.1989 6.54246 13.6957 5.75893 13.6957C4.68942 13.6957 4.06651 12.8556 4.06651 11.6156C4.06651 9.16809 6.19379 8.72381 8.20746 8.72381V9.3458ZM11.0164 16.3452C10.8323 16.5148 10.5659 16.5269 10.3582 16.4138C9.43368 15.6222 9.26914 15.2547 8.75985 14.4994C7.23197 16.1069 6.1507 16.5875 4.16837 16.5875C1.82562 16.5875 0 15.0972 0 12.1124C0 9.782 1.22622 8.19472 2.96957 7.41926C4.48178 6.73265 6.59339 6.61148 8.20746 6.42166V6.05008C8.20746 5.36751 8.25839 4.55973 7.87054 3.97006C7.52971 3.44096 6.87938 3.22286 6.3074 3.22286C5.24572 3.22286 4.29765 3.78427 4.06651 4.94746C4.0195 5.20595 3.83537 5.4604 3.58464 5.47252L0.88147 5.17364C0.654246 5.12114 0.403516 4.93131 0.466199 4.57185C1.0891 1.19535 4.04692 0.177551 6.69525 0.177551C8.05075 0.177551 9.82153 0.549129 10.891 1.60731C12.2465 2.91187 12.1173 4.65263 12.1173 6.54686V11.0219C12.1173 12.3669 12.6579 12.9566 13.1672 13.6836C13.3474 13.942 13.3866 14.253 13.1594 14.4469C12.5913 14.9356 11.5806 15.8444 11.0242 16.3533L11.0164 16.3452'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_943_7977'>
            <rect
              width='90'
              height='27.9612'
              fill='white'
              transform='translate(0 0.177307)'
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  googleLogo: () => {
    return (
      <svg
        width='90'
        height='31'
        viewBox='0 0 90 31'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M38.2996 15.5467C38.2996 19.7547 34.9941 22.8555 30.9374 22.8555C26.8808 22.8555 23.5753 19.7547 23.5753 15.5467C23.5753 11.3091 26.8808 8.23798 30.9374 8.23798C34.9941 8.23798 38.2996 11.3091 38.2996 15.5467ZM35.0768 15.5467C35.0768 12.9172 33.161 11.118 30.9374 11.118C28.7139 11.118 26.7981 12.9172 26.7981 15.5467C26.7981 18.1499 28.7139 19.9755 30.9374 19.9755C33.161 19.9755 35.0768 18.1466 35.0768 15.5467Z'
          fill='#EA4335'
        />
        <path
          d='M54.1819 15.5467C54.1819 19.7547 50.8764 22.8555 46.8198 22.8555C42.7632 22.8555 39.4576 19.7547 39.4576 15.5467C39.4576 11.3124 42.7632 8.23798 46.8198 8.23798C50.8764 8.23798 54.1819 11.3091 54.1819 15.5467ZM50.9591 15.5467C50.9591 12.9172 49.0433 11.118 46.8198 11.118C44.5962 11.118 42.6804 12.9172 42.6804 15.5467C42.6804 18.1499 44.5962 19.9755 46.8198 19.9755C49.0433 19.9755 50.9591 18.1466 50.9591 15.5467Z'
          fill='#FFDA55'
        />
        <path
          d='M69.4025 8.67953V21.801C69.4025 27.1985 66.2062 29.403 62.4275 29.403C58.8705 29.403 56.7297 27.0338 55.9223 25.0962L58.7282 23.933C59.2279 25.1226 60.4521 26.5263 62.4242 26.5263C64.8429 26.5263 66.3418 25.0402 66.3418 22.2426V21.1914H66.2293C65.508 22.0778 64.1183 22.8522 62.3646 22.8522C58.6951 22.8522 55.3334 19.669 55.3334 15.5731C55.3334 11.4475 58.6951 8.23798 62.3646 8.23798C64.115 8.23798 65.5047 9.01235 66.2293 9.87239H66.3418V8.68283H69.4025V8.67953ZM66.5702 15.5731C66.5702 12.9995 64.8463 11.118 62.6525 11.118C60.429 11.118 58.5661 12.9995 58.5661 15.5731C58.5661 18.1203 60.429 19.9755 62.6525 19.9755C64.8463 19.9755 66.5702 18.1203 66.5702 15.5731Z'
          fill='#0099FF'
        />
        <path
          d='M74.4486 0.988525V22.4073H71.3052V0.988525H74.4486Z'
          fill='#38C99F'
        />
        <path
          d='M86.6978 17.9522L89.1993 19.613C88.392 20.8026 86.4464 22.8522 83.0846 22.8522C78.9155 22.8522 75.8019 19.6426 75.8019 15.5434C75.8019 11.1971 78.942 8.23468 82.7239 8.23468C86.5324 8.23468 88.3953 11.2531 89.0041 12.8842L89.3383 13.7146L79.5276 17.7611C80.2787 19.2274 81.4467 19.9755 83.0846 19.9755C84.7258 19.9755 85.864 19.1714 86.6978 17.9522ZM78.9982 15.3226L85.5563 12.6107C85.1956 11.6979 84.1103 11.062 82.8331 11.062C81.1953 11.062 78.9155 12.502 78.9982 15.3226Z'
          fill='#EA4335'
        />
        <path
          d='M11.677 13.6454V10.5446H22.1693C22.2718 11.085 22.3248 11.7243 22.3248 12.4163C22.3248 14.7427 21.6862 17.6194 19.6281 19.669C17.6262 21.745 15.0685 22.8521 11.6803 22.8521C5.40014 22.8521 0.119263 17.7578 0.119263 11.5035C0.119263 5.24922 5.40014 0.154846 11.6803 0.154846C15.1546 0.154846 17.6296 1.51247 19.4891 3.28199L17.2921 5.47C15.9586 4.22441 14.152 3.25562 11.677 3.25562C7.09095 3.25562 3.50419 6.93636 3.50419 11.5035C3.50419 16.0706 7.09095 19.7514 11.677 19.7514C14.6516 19.7514 16.3457 18.5618 17.431 17.481C18.3112 16.6045 18.8902 15.3523 19.1185 13.6421L11.677 13.6454Z'
          fill='#0099FF'
        />
      </svg>
    );
  },
  airbnbLogo: () => {
    return (
      <svg
        width='90'
        height='29'
        viewBox='0 0 90 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_943_7975)'>
          <path
            d='M25.7996 19.9941C25.6584 19.6533 25.5261 19.2951 25.3849 18.9892L24.732 17.53L24.7055 17.5038C22.7643 13.3096 20.6908 9.04555 18.4937 4.85138L18.4055 4.67662C18.1849 4.26594 17.9643 3.81157 17.7349 3.39216C17.4525 2.8941 17.179 2.36109 16.729 1.85429C16.2904 1.32402 15.7383 0.896787 15.1127 0.603427C14.4871 0.310068 13.8036 0.157898 13.1114 0.157898C12.4192 0.157898 11.7356 0.310068 11.11 0.603427C10.4844 0.896787 9.93235 1.32402 9.49372 1.85429C9.07901 2.36109 8.77019 2.8941 8.48783 3.39216C8.26724 3.84652 8.04666 4.29216 7.81724 4.70284L7.72901 4.87759C5.56724 9.07177 3.45842 13.3358 1.51724 17.53L1.4643 17.5824C1.27019 18.0368 1.04077 18.5087 0.820186 19.0155C0.679009 19.3213 0.537833 19.6533 0.396656 20.0203C0.0155087 20.9813 -0.106204 22.024 0.0435143 23.0458C0.193232 24.0675 0.609213 25.033 1.25046 25.8471C1.89171 26.6611 2.73609 27.2957 3.70038 27.6882C4.66468 28.0807 5.71561 28.2176 6.7496 28.0854C7.74089 27.9561 8.69543 27.6292 9.55548 27.1242C10.7025 26.4863 11.8055 25.5601 13.0408 24.2232C14.2761 25.5601 15.4055 26.4863 16.5261 27.1329C17.6037 27.7593 18.824 28.105 20.0731 28.1378C21.5196 28.1437 22.9194 27.6312 24.0141 26.6949C25.1088 25.7586 25.8245 24.4617 26.029 23.0436C26.2653 22.0246 26.1854 20.9586 25.7996 19.9854V19.9941ZM13.129 21.4446C11.6114 19.5223 10.6231 17.7572 10.2878 16.2456C10.1489 15.6854 10.119 15.1042 10.1996 14.5329C10.2614 14.0873 10.429 13.6941 10.6584 13.3621C11.1878 12.6019 12.1143 12.13 13.129 12.13C13.6109 12.1154 14.0889 12.2196 14.5201 12.4331C14.9513 12.6466 15.3222 12.9628 15.5996 13.3533C15.829 13.7028 15.9967 14.0873 16.0496 14.5329C16.1378 15.0397 16.1025 15.6252 15.9614 16.2456C15.6261 17.731 14.6378 19.5135 13.129 21.4446ZM24.3702 22.7378C24.2699 23.4577 23.9809 24.1391 23.532 24.714C23.083 25.2889 22.4898 25.7373 21.8114 26.0145C21.1408 26.2941 20.3996 26.3727 19.6761 26.2941C18.9702 26.2067 18.2643 25.9795 17.5408 25.5601C16.3395 24.8248 15.2592 23.9113 14.3378 22.8514C16.1908 20.5795 17.3114 18.5087 17.7349 16.665C17.9378 15.7912 17.9643 15.0048 17.8761 14.2795C17.7659 13.5921 17.507 12.9364 17.1172 12.3572C16.6722 11.7292 16.0781 11.219 15.3873 10.8717C14.6965 10.5243 13.9301 10.3503 13.1555 10.365C11.5231 10.365 10.0672 11.1164 9.18489 12.3485C8.78769 12.9262 8.53099 13.5871 8.43489 14.2795C8.32019 15.0135 8.34666 15.8261 8.57607 16.665C8.9996 18.5087 10.1467 20.6057 11.9731 22.8689C11.0674 23.949 9.98462 24.8706 8.77018 25.5951C8.03783 26.0145 7.34077 26.2329 6.63489 26.3203C5.53714 26.4596 4.42826 26.1641 3.54927 25.4982C2.67028 24.8322 2.09223 23.8497 1.94077 22.764C1.85254 22.065 1.9143 21.3659 2.19666 20.5795C2.28489 20.2999 2.41724 20.0203 2.55842 19.6883C2.75254 19.2339 2.98195 18.7621 3.20254 18.2902L3.23783 18.229C5.14371 14.0611 7.22607 9.80575 9.38783 5.63779L9.47607 5.46303C9.69666 5.04361 9.91724 4.59798 10.1467 4.17856C10.3761 3.73293 10.6231 3.30478 10.9408 2.95526C11.2157 2.63023 11.5593 2.36884 11.9473 2.18949C12.3352 2.01014 12.7582 1.91719 13.1864 1.91719C13.6145 1.91719 14.0375 2.01014 14.4255 2.18949C14.8134 2.36884 15.157 2.63023 15.432 2.95526C15.7408 3.30478 15.9967 3.73293 16.2261 4.17856C16.4467 4.59798 16.6672 5.05235 16.8967 5.46303L16.9849 5.63779C19.1378 9.80575 21.2202 14.0611 23.1614 18.229L23.1878 18.2553C23.4172 18.7096 23.6114 19.2164 23.8319 19.6533C23.9731 19.9941 24.1143 20.265 24.2025 20.5533C24.3702 21.3397 24.4584 22.0388 24.3702 22.7378ZM36.6525 21.2524C35.9876 21.262 35.3291 21.1232 34.7258 20.8464C34.1224 20.5696 33.5897 20.1618 33.1672 19.6533C32.2179 18.5698 31.714 17.1727 31.7555 15.7388C31.741 14.2736 32.2611 12.8525 33.2202 11.7368C33.6638 11.2218 34.2161 10.8094 34.8381 10.5286C35.4601 10.2478 36.1366 10.1055 36.8202 10.1116C37.4634 10.0941 38.1004 10.239 38.6715 10.5325C39.2426 10.8259 39.729 11.2584 40.0849 11.7892L40.1731 10.4174H42.7496V20.9727H40.1643L40.0761 19.4349C39.7092 20.0017 39.202 20.4662 38.6028 20.7843C38.0037 21.1024 37.3323 21.2635 36.6525 21.2524ZM37.3231 18.7358C37.8349 18.7358 38.2849 18.596 38.7084 18.3426C39.0967 18.063 39.4143 17.696 39.6614 17.2504C39.8819 16.8048 39.9967 16.2718 39.9967 15.6776C40.0311 15.1615 39.9296 14.6455 39.7023 14.1799C39.4749 13.7143 39.1294 13.315 38.6996 13.0213C38.2866 12.7665 37.8097 12.6314 37.3231 12.6314C36.8365 12.6314 36.3597 12.7665 35.9467 13.0213C35.5584 13.3009 35.2408 13.6679 34.9937 14.1135C34.7604 14.605 34.6456 15.1434 34.6584 15.6863C34.624 16.2024 34.7255 16.7185 34.9528 17.1841C35.1802 17.6497 35.5256 18.0489 35.9555 18.3426C36.3702 18.596 36.8202 18.7358 37.3231 18.7358ZM47.1614 7.56886C47.1614 7.87468 47.1084 8.15429 46.9672 8.38148C46.8261 8.59992 46.6319 8.80089 46.3761 8.9407C46.1202 9.08051 45.8467 9.13293 45.5643 9.13293C45.2819 9.13293 44.9996 9.08051 44.7437 8.9407C44.5017 8.80728 44.2982 8.61477 44.1525 8.38148C44.0159 8.13256 43.9489 7.85202 43.9584 7.56886C43.9584 7.25429 44.0202 6.97468 44.1525 6.75623C44.2937 6.4941 44.4967 6.33682 44.7437 6.19701C44.9996 6.0572 45.2731 5.99604 45.5643 5.99604C45.8452 5.98963 46.1229 6.0555 46.3703 6.18722C46.6178 6.31893 46.8265 6.51199 46.9761 6.7475C47.1045 7.00225 47.1681 7.28421 47.1614 7.56886ZM44.1614 20.9378V10.3999H46.9672V20.9553H44.1525L44.1614 20.9378ZM54.4672 13.1611V13.196C54.3349 13.1349 54.1584 13.1087 54.0261 13.0824C53.8496 13.0475 53.7084 13.0475 53.5408 13.0475C52.7555 13.0475 52.1643 13.2747 51.7761 13.7465C51.3525 14.2271 51.1584 14.8999 51.1584 15.765V20.9465H48.3437V10.3912H50.929L51.0172 11.9902C51.2996 11.431 51.6349 11.0116 52.1114 10.697C52.5853 10.3914 53.1433 10.2387 53.7084 10.2601C53.9114 10.2601 54.1055 10.2776 54.2731 10.3125C54.3614 10.3388 54.4143 10.3388 54.4672 10.365V13.1611ZM55.5966 20.9378V6.06594H58.4025V11.7456C58.7996 11.2388 59.2496 10.8456 59.8143 10.5397C60.7083 10.1057 61.7239 9.98253 62.6972 10.1902C63.6706 10.3979 64.5448 10.9243 65.179 11.6844C66.1305 12.7702 66.6344 14.1708 66.5908 15.6077C66.6053 17.0728 66.0852 18.4939 65.1261 19.6096C64.6824 20.1246 64.1302 20.537 63.5082 20.8178C62.8862 21.0986 62.2096 21.241 61.5261 21.2349C60.8829 21.2523 60.2458 21.1075 59.6747 20.814C59.1036 20.5205 58.6172 20.088 58.2614 19.5572L58.1731 20.929L55.5966 20.9553V20.9378ZM61.0231 18.7358C61.5261 18.7358 61.9761 18.596 62.3996 18.3426C62.7878 18.063 63.1055 17.696 63.3525 17.2504C63.582 16.8048 63.6878 16.2718 63.6878 15.6776C63.6878 15.0922 63.582 14.5591 63.3525 14.1135C63.1208 13.6838 62.7953 13.3107 62.3996 13.0213C61.9866 12.7665 61.5097 12.6314 61.0231 12.6314C60.5365 12.6314 60.0597 12.7665 59.6467 13.0213C59.2496 13.3009 58.9408 13.6679 58.6849 14.1135C58.4516 14.605 58.3368 15.1434 58.3496 15.6863C58.3152 16.2024 58.4166 16.7185 58.644 17.1841C58.8713 17.6497 59.2168 18.0489 59.6467 18.3426C60.0614 18.596 60.5114 18.7358 61.0231 18.7358ZM67.6496 20.9465V10.3912H70.2349L70.3231 11.763C70.648 11.2372 71.1089 10.8068 71.658 10.5165C72.2072 10.2261 72.8247 10.0863 73.4467 10.1116C74.1579 10.0994 74.857 10.2952 75.4565 10.6744C76.056 11.0536 76.5293 11.5994 76.8172 12.2436C77.1261 12.9077 77.2937 13.729 77.2937 14.6465V20.9727H74.479V15.0135C74.479 14.2795 74.3114 13.7028 73.9761 13.2747C73.6408 12.8553 73.1819 12.6281 72.5996 12.6281C72.1761 12.6281 71.8055 12.7155 71.479 12.9077C71.1702 13.1087 70.9143 13.3621 70.7202 13.7203C70.5239 14.0824 70.4266 14.4891 70.4378 14.8999V20.9465H67.6496ZM78.6967 20.9465V6.0572H81.5114V11.7368C81.8926 11.2272 82.3886 10.8126 82.9599 10.5259C83.5312 10.2393 84.1621 10.0884 84.8025 10.0854C85.4674 10.0757 86.126 10.2145 86.7293 10.4913C87.3327 10.7681 87.8653 11.1759 88.2878 11.6844C89.2325 12.7701 89.7329 14.1664 89.6908 15.599C89.7061 17.0642 89.1859 18.4856 88.2261 19.6009C87.7824 20.1159 87.2302 20.5283 86.6082 20.8091C85.9862 21.0899 85.3096 21.2323 84.6261 21.2261C83.9829 21.2436 83.3458 21.0987 82.7747 20.8053C82.2036 20.5118 81.7172 20.0793 81.3614 19.5485L81.282 20.9203L78.6967 20.9465ZM84.1496 18.7358C84.6614 18.7358 85.1114 18.596 85.5261 18.3426C85.9231 18.063 86.2319 17.696 86.4878 17.2504C86.7084 16.8048 86.8231 16.2718 86.8231 15.6776C86.8575 15.1615 86.7561 14.6455 86.5287 14.1799C86.3014 13.7143 85.9559 13.315 85.5261 13.0213C85.1131 12.7665 84.6362 12.6314 84.1496 12.6314C83.663 12.6314 83.1861 12.7665 82.7731 13.0213C82.3849 13.3009 82.0672 13.6679 81.8202 14.1135C81.5739 14.6006 81.4584 15.1422 81.4849 15.6863C81.4505 16.2024 81.5519 16.7185 81.7793 17.1841C82.0066 17.6497 82.3521 18.0489 82.7819 18.3426C83.1967 18.596 83.6202 18.7358 84.1496 18.7358Z'
            fill='#FF385C'
          />
        </g>
        <defs>
          <clipPath id='clip0_943_7975'>
            <rect
              width='90'
              height='27.9612'
              fill='white'
              transform='translate(0 0.177307)'
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  editIcon: (color = '#2C689F') => {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_358_10867)'>
          <path
            d='M7.76481 1.88281H2.82363C2.44921 1.88281 2.09012 2.03155 1.82536 2.29631C1.5606 2.56107 1.41187 2.92015 1.41187 3.29458V13.1769C1.41187 13.5514 1.5606 13.9104 1.82536 14.1752C2.09012 14.44 2.44921 14.5887 2.82363 14.5887H12.706C13.0804 14.5887 13.4395 14.44 13.7043 14.1752C13.969 13.9104 14.1177 13.5514 14.1177 13.1769V8.23575'
            stroke={color}
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12.7765 1.37999C13.0573 1.09917 13.4382 0.941406 13.8353 0.941406C14.2325 0.941406 14.6133 1.09917 14.8942 1.37999C15.175 1.6608 15.3327 2.04167 15.3327 2.43881C15.3327 2.83594 15.175 3.21681 14.8942 3.49763L8.18828 10.2035L5.36475 10.9094L6.07063 8.08587L12.7765 1.37999Z'
            stroke={color}
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_358_10867'>
            <rect width='16' height='16' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  },
  dashboard: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.2 13.5992H14.4V3.19922H11.2V13.5992ZM1.6001 5.59922H9.6001V3.19922H1.6001V5.59922ZM1.6001 9.59922H9.6001V7.19922H1.6001V9.59922ZM1.6001 13.5992H9.6001V11.1992H1.6001V13.5992ZM0 15.1996H16V1.59961H0V15.1996Z'
      />
      <mask
        id='mask0_358_11661'
        style={{
          maskType: 'luminance',
        }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='1'
        width='16'
        height='15'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2 13.5992H14.4V3.19922H11.2V13.5992ZM1.6001 5.59922H9.6001V3.19922H1.6001V5.59922ZM1.6001 9.59922H9.6001V7.19922H1.6001V9.59922ZM1.6001 13.5992H9.6001V11.1992H1.6001V13.5992ZM0 15.1996H16V1.59961H0V15.1996Z'
        />
      </mask>
      <g mask='url(#mask0_358_11661)'>
        <rect width='16' height='16' />
      </g>
    </svg>
  ),
  merchants: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.2577 2.304C14.2081 1.9032 13.8665 1.6 13.4625 1.6H11.4793C11.6689 2.8912 11.8345 4.6544 11.5561 5.7256C12.8433 5.8312 13.9265 5.5712 14.3009 5.3592C14.4553 4.8928 14.4273 3.672 14.2577 2.304ZM12.8001 7.3232C11.8945 7.392 10.8753 7.3368 10.0353 7.0552C9.3913 7.248 8.60731 7.352 7.82971 7.352C7.07291 7.352 6.33131 7.2528 5.74091 7.0544C5.05691 7.26 4.17851 7.38 3.20011 7.3432V13.6C3.20011 14.0416 3.55771 14.4 4.00011 14.4H7.20011V12C7.20011 11.5584 7.55771 11.2 8.0001 11.2C8.44171 11.2 8.80011 11.5584 8.80011 12V14.4H12.0001C12.4417 14.4 12.8001 14.0416 12.8001 13.6V7.3232ZM4.43131 5.696C4.18411 4.6048 4.32731 2.872 4.49451 1.6H2.51611C2.10491 1.6 1.76331 1.9136 1.71931 2.3224C1.56651 3.7288 1.55371 4.9784 1.71291 5.444C2.32411 5.7856 3.69371 5.788 4.43131 5.696ZM6.00891 5.444C6.81131 5.892 9.1953 5.82 10.0081 5.3592C10.1881 4.8136 10.1193 3.2376 9.86651 1.6H6.10331C5.87211 3.284 5.82251 4.9 6.00891 5.444ZM15.4929 6.4536C15.2513 6.6944 14.8633 6.8872 14.4001 7.0336V14.4C14.4001 15.2832 13.6833 16 12.8001 16H3.20011C2.31611 16 1.60011 15.2832 1.60011 14.4V7.1048C1.09611 6.9568 0.684105 6.7424 0.450505 6.4536C-0.227895 5.6136 0.00170537 3.0064 0.228105 1.3744C0.337705 0.584 1.01451 0 1.81211 0H14.1545C14.9441 0 15.6145 0.5712 15.7361 1.3512C15.9929 3.0048 16.2641 5.6824 15.4929 6.4536ZM5.60011 8C5.15771 8 4.80011 8.3584 4.80011 8.8V10.4C4.80011 10.8416 5.15771 11.2 5.60011 11.2C6.04171 11.2 6.40011 10.8416 6.40011 10.4V8.8C6.40011 8.3584 6.04171 8 5.60011 8ZM11.2001 8.8V10.4C11.2001 10.8416 10.8417 11.2 10.4001 11.2C9.95771 11.2 9.60011 10.8416 9.60011 10.4V8.8C9.60011 8.3584 9.95771 8 10.4001 8C10.8417 8 11.2001 8.3584 11.2001 8.8Z'
      />
      <mask
        id='mask0_303_10292'
        style={{
          maskType: 'luminance',
        }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.2577 2.304C14.2081 1.9032 13.8665 1.6 13.4625 1.6H11.4793C11.6689 2.8912 11.8345 4.6544 11.5561 5.7256C12.8433 5.8312 13.9265 5.5712 14.3009 5.3592C14.4553 4.8928 14.4273 3.672 14.2577 2.304ZM12.8001 7.3232C11.8945 7.392 10.8753 7.3368 10.0353 7.0552C9.3913 7.248 8.60731 7.352 7.82971 7.352C7.07291 7.352 6.33131 7.2528 5.74091 7.0544C5.05691 7.26 4.17851 7.38 3.20011 7.3432V13.6C3.20011 14.0416 3.55771 14.4 4.00011 14.4H7.20011V12C7.20011 11.5584 7.55771 11.2 8.0001 11.2C8.44171 11.2 8.80011 11.5584 8.80011 12V14.4H12.0001C12.4417 14.4 12.8001 14.0416 12.8001 13.6V7.3232ZM4.43131 5.696C4.18411 4.6048 4.32731 2.872 4.49451 1.6H2.51611C2.10491 1.6 1.76331 1.9136 1.71931 2.3224C1.56651 3.7288 1.55371 4.9784 1.71291 5.444C2.32411 5.7856 3.69371 5.788 4.43131 5.696ZM6.00891 5.444C6.81131 5.892 9.1953 5.82 10.0081 5.3592C10.1881 4.8136 10.1193 3.2376 9.86651 1.6H6.10331C5.87211 3.284 5.82251 4.9 6.00891 5.444ZM15.4929 6.4536C15.2513 6.6944 14.8633 6.8872 14.4001 7.0336V14.4C14.4001 15.2832 13.6833 16 12.8001 16H3.20011C2.31611 16 1.60011 15.2832 1.60011 14.4V7.1048C1.09611 6.9568 0.684105 6.7424 0.450505 6.4536C-0.227895 5.6136 0.00170537 3.0064 0.228105 1.3744C0.337705 0.584 1.01451 0 1.81211 0H14.1545C14.9441 0 15.6145 0.5712 15.7361 1.3512C15.9929 3.0048 16.2641 5.6824 15.4929 6.4536ZM5.60011 8C5.15771 8 4.80011 8.3584 4.80011 8.8V10.4C4.80011 10.8416 5.15771 11.2 5.60011 11.2C6.04171 11.2 6.40011 10.8416 6.40011 10.4V8.8C6.40011 8.3584 6.04171 8 5.60011 8ZM11.2001 8.8V10.4C11.2001 10.8416 10.8417 11.2 10.4001 11.2C9.95771 11.2 9.60011 10.8416 9.60011 10.4V8.8C9.60011 8.3584 9.95771 8 10.4001 8C10.8417 8 11.2001 8.3584 11.2001 8.8Z'
        />
      </mask>
      <g mask='url(#mask0_303_10292)'>
        <rect width='16' height='16' />
      </g>
    </svg>
  ),
  regionMapping: (fill: string) => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z'
        stroke={fill}
        strokeWidth='1.5'
      />
      <path
        opacity='0.7'
        d='M1.72729 6.81836H16.2727M1.72729 11.182H16.2727'
        stroke={fill}
        strokeWidth='1.5'
      />
      <path
        d='M9.00001 1C8.27274 1 5.36365 3.90909 5.36365 9C5.36365 14.0909 8.27274 17 9.00001 17M9.00001 1C9.72728 1 12.6364 3.90909 12.6364 9C12.6364 14.0909 9.72728 17 9.00001 17'
        stroke={fill}
        strokeWidth='1.5'
      />
    </svg>
  ),
  merchantRanking: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={fill}
      stroke={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_303_10444)'>
        <path
          d='M15.2291 4.57129H12.9455C12.849 4.57129 12.7565 4.609 12.6883 4.67613C12.6201 4.74325 12.5818 4.8343 12.5818 4.92923V14.5006H11.5055V6.51849C11.5055 6.42356 11.4672 6.33252 11.399 6.26539C11.3308 6.19826 11.2383 6.16055 11.1418 6.16055H8.85819C8.76175 6.16055 8.66926 6.19826 8.60106 6.26539C8.53286 6.33252 8.49455 6.42356 8.49455 6.51849V14.5006H7.41819V8.1006C7.41819 8.00566 7.37988 7.91462 7.31168 7.84749C7.24349 7.78037 7.151 7.74265 7.05455 7.74265H4.77092C4.67506 7.74449 4.58364 7.78279 4.51585 7.84952C4.44805 7.91625 4.40914 8.00624 4.40728 8.1006V14.5006H3.33092V11.3006C3.33092 11.2057 3.2926 11.1146 3.22441 11.0475C3.15621 10.9804 3.06372 10.9427 2.96728 10.9427H0.683644C0.587784 10.9445 0.49637 10.9828 0.428574 11.0495C0.360778 11.1163 0.321869 11.2062 0.320007 11.3006V14.88C0.321869 14.9744 0.360778 15.0644 0.428574 15.1311C0.49637 15.1978 0.587784 15.2361 0.683644 15.238H15.2291C15.3255 15.238 15.418 15.2002 15.4862 15.1331C15.5544 15.066 15.5927 14.9749 15.5927 14.88V4.92923C15.5927 4.8343 15.5544 4.74325 15.4862 4.67613C15.418 4.609 15.3255 4.57129 15.2291 4.57129ZM2.60364 14.5006H1.04728V11.6371H2.60364V14.5006ZM6.69092 14.5006H5.1491V8.43706H6.70546L6.69092 14.5006ZM10.7782 14.5006H9.22183V6.87643H10.7782V14.5006ZM14.8655 14.5006H13.3091V5.28717H14.8655V14.5006Z'
          strokeWidth='0.5'
        />
        <path
          d='M1.82089 7.19013C1.57242 7.18708 1.32865 7.25787 1.12061 7.39352C0.912472 7.52923 0.749512 7.72372 0.652529 7.95222C0.555545 8.18073 0.528941 8.43289 0.576119 8.67655C0.623296 8.92022 0.742111 9.14432 0.917385 9.32031C1.09266 9.49629 1.31645 9.61621 1.56023 9.6648C1.80401 9.71339 2.05677 9.68846 2.28631 9.59319C2.51585 9.49792 2.71181 9.3366 2.84917 9.12976C2.98648 8.923 3.05903 8.68013 3.05754 8.43206M1.82089 7.19013C2.14949 7.19229 2.46395 7.32402 2.69565 7.55667C2.92735 7.78932 3.05747 8.104 3.05754 8.43206M1.82089 7.19013C1.82078 7.19013 1.82068 7.19013 1.82058 7.19013L1.81994 7.29013L1.8212 7.19014C1.82109 7.19014 1.82099 7.19014 1.82089 7.19013ZM3.05754 8.43206C3.05754 8.43217 3.05754 8.43228 3.05754 8.43238L2.95754 8.43238L3.05754 8.43176C3.05754 8.43186 3.05754 8.43196 3.05754 8.43206ZM1.81824 8.75893L1.81824 8.75892L1.81656 8.75897C1.75131 8.76118 1.6869 8.74389 1.63159 8.70935C1.57629 8.67481 1.53262 8.6246 1.50615 8.56518C1.47968 8.50577 1.4716 8.43984 1.48294 8.37583C1.49428 8.31182 1.52452 8.25262 1.56983 8.20583C1.61515 8.15903 1.67346 8.12677 1.73732 8.11323C1.80118 8.09969 1.86763 8.10549 1.92816 8.12987C1.98868 8.15426 2.04048 8.1961 2.07696 8.25001C2.11343 8.30392 2.13292 8.36744 2.13294 8.43244L2.13297 8.43412C2.1337 8.47603 2.12615 8.51767 2.11075 8.55667C2.09535 8.59567 2.07238 8.63128 2.04317 8.66145C2.01395 8.69162 1.97905 8.71577 1.94046 8.7325C1.90186 8.74923 1.86033 8.75821 1.81824 8.75893Z'
          strokeWidth='0.2'
        />
        <path
          d='M6.21958 5.1482L6.21957 5.1482V5.1499C6.21957 5.23643 6.18512 5.31946 6.12372 5.38071C6.06232 5.44197 5.979 5.47643 5.89206 5.47643C5.80417 5.47643 5.71992 5.44159 5.65784 5.37965C5.59576 5.31772 5.56093 5.23377 5.56093 5.14628C5.56093 5.05879 5.59576 4.97484 5.65784 4.91291C5.71992 4.85097 5.80417 4.81613 5.89206 4.81613H5.89208C5.93559 4.81612 5.97866 4.82476 6.01878 4.84154C6.05889 4.85831 6.09525 4.88288 6.12572 4.9138C6.1562 4.94472 6.18018 4.98137 6.19629 5.02161C6.2124 5.06185 6.22032 5.10488 6.21958 5.1482ZM4.64722 5.15053C4.64878 5.3977 4.72377 5.63883 4.86267 5.84344C5.00158 6.04805 5.19815 6.20693 5.4275 6.30003C5.65685 6.39313 5.90871 6.41628 6.15124 6.36657C6.39377 6.31685 6.6161 6.19649 6.79012 6.02067C6.96414 5.84484 7.08202 5.62146 7.12882 5.37874C7.17562 5.13602 7.14924 4.88491 7.053 4.65717C6.95677 4.42944 6.79504 4.23532 6.58828 4.09935C6.38152 3.96337 6.13902 3.89164 5.89144 3.89319C5.72704 3.89422 5.56445 3.92754 5.41295 3.99127C5.26145 4.05499 5.124 4.14788 5.00845 4.26462C4.8929 4.38137 4.80152 4.51969 4.73954 4.6717C4.67755 4.8237 4.64618 4.98641 4.64722 5.15053Z'
          strokeWidth='0.2'
        />
        <path
          d='M9.64401 3.60323V3.60321C9.64401 3.5186 9.67769 3.43741 9.73773 3.37751C9.79777 3.3176 9.87925 3.2839 9.96427 3.2839H9.96428C10.0503 3.28389 10.1328 3.31759 10.194 3.37766C10.2548 3.43733 10.2899 3.51828 10.2918 3.60323C10.2899 3.68915 10.2549 3.77111 10.1939 3.83197C10.1329 3.89284 10.0506 3.92788 9.96429 3.92973C9.87893 3.92785 9.7977 3.89281 9.73788 3.83211C9.67768 3.77101 9.64399 3.68881 9.64401 3.60323ZM8.71942 3.60258C8.71786 3.85042 8.7902 4.0931 8.92721 4.29979C9.06422 4.50647 9.2597 4.6678 9.48878 4.76331C9.71787 4.85883 9.97022 4.88422 10.2138 4.83628C10.4574 4.78833 10.6812 4.66921 10.8568 4.49401C11.0324 4.31881 11.1518 4.09545 11.1999 3.8523C11.248 3.60915 11.2225 3.35723 11.1267 3.12857C11.031 2.89992 10.8692 2.70487 10.6621 2.5682C10.455 2.43154 10.2119 2.35941 9.96364 2.36096C9.63436 2.36302 9.31911 2.49444 9.08621 2.72682C8.85329 2.95921 8.72149 3.27385 8.71942 3.60258Z'
          strokeWidth='0.2'
        />
        <path
          d='M14.3567 1.91118V1.9112C14.3567 1.99581 14.323 2.077 14.263 2.1369C14.203 2.19681 14.1215 2.23051 14.0365 2.23051C13.9515 2.23051 13.87 2.19681 13.8099 2.1369C13.7499 2.077 13.7162 1.99581 13.7162 1.9112V1.91118C13.7162 1.8256 13.7499 1.7434 13.8101 1.6823C13.8699 1.6216 13.9511 1.58656 14.0365 1.58468C14.1218 1.58656 14.203 1.6216 14.2629 1.6823C14.3231 1.7434 14.3567 1.82561 14.3567 1.91118ZM12.7916 1.91183C12.7932 2.15724 12.8675 2.39667 13.0053 2.59992C13.1431 2.80317 13.338 2.96114 13.5656 3.05393C13.7932 3.14672 14.0432 3.17019 14.2841 3.12139C14.525 3.07259 14.7461 2.9537 14.9194 2.77968C15.0927 2.60565 15.2105 2.38429 15.2579 2.14349C15.3054 1.90268 15.2802 1.65327 15.1858 1.42671C15.0913 1.20015 14.9317 1.00661 14.7272 0.870484C14.5226 0.734357 14.2823 0.661724 14.0365 0.661719C13.8724 0.661715 13.7099 0.694094 13.5583 0.756995C13.4068 0.819897 13.2692 0.912083 13.1535 1.02826C13.0378 1.14444 12.9463 1.28231 12.8841 1.43395C12.822 1.5856 12.7906 1.74801 12.7916 1.91183Z'
          strokeWidth='0.2'
        />
      </g>
      <defs>
        <clipPath id='clip0_303_10444'>
          <rect width='16' height='16' />
        </clipPath>
      </defs>
    </svg>
  ),
  categoryMapping: (fill: string) => (
    <svg
      width='15'
      height='17'
      viewBox='0 0 15 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5151 12.6702V12.2679H13.6223V15.375H10.5151V13.8214V13.4203V13.0714V12.6702ZM10.5151 7.66071V7.3125V6.91071V6.50893H13.6223V9.61607H10.5151V8.0625V7.66071ZM3.45536 3.85714H3.05357H2.70536H2.30357H0.75V0.75H3.85714V3.85714H3.45536Z'
        stroke={fill}
        strokeWidth='1.5'
      />
    </svg>
  ),
  rocket: (strokeColor = '#F8F9FF') => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.35156 14.4219C6.46094 17.0703 2.92969 17.0703 2.92969 17.0703C2.92969 17.0703 2.92969 13.539 5.57812 12.6484'
        stroke={strokeColor}
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.3047 8.23438L10 13.5391L6.46094 10L11.7656 4.69532C13.7734 2.68751 15.7813 2.71094 16.6406 2.83594C16.7732 2.85364 16.8963 2.91448 16.9909 3.00907C17.0855 3.10367 17.1464 3.22677 17.1641 3.35938C17.2891 4.21876 17.3125 6.22657 15.3047 8.23438Z'
        stroke={strokeColor}
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.4219 9.11723V14.1641C14.4195 14.329 14.3521 14.4862 14.2344 14.6016L11.7109 17.1329C11.6309 17.2128 11.5306 17.2695 11.4208 17.297C11.3111 17.3244 11.1959 17.3216 11.0876 17.2887C10.9794 17.2558 10.882 17.1941 10.8061 17.1103C10.7301 17.0264 10.6783 16.9235 10.6562 16.8125L10 13.5391'
        stroke={strokeColor}
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8828 5.5781H5.83588C5.67102 5.58045 5.51377 5.64784 5.39838 5.7656L2.86713 8.28904C2.78716 8.3691 2.73043 8.46936 2.70299 8.57914C2.67554 8.68891 2.67842 8.80408 2.7113 8.91235C2.74418 9.02062 2.80584 9.11793 2.8897 9.19391C2.97355 9.26988 3.07646 9.32166 3.18744 9.34373L6.46088 9.99998'
        stroke={strokeColor}
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  couponRanking: (fill: string) => (
    <svg
      width='17'
      height='14'
      viewBox='0 0 17 14'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M6.61316 8.3062L7.1199 7.79947L6.20033 6.87956L5.69359 7.38698C5.39857 7.19166 5.0694 7.04586 4.71769 6.95434V6.19629H3.08548V6.95434C2.72592 7.04722 2.38923 7.19712 2.08943 7.39893L1.60284 6.91234L0.682931 7.83191L1.17771 8.32669C0.988542 8.6166 0.846493 8.93894 0.757712 9.2828H0V10.9136H0.75737C0.848541 11.2657 0.994347 11.5959 1.19001 11.8909L0.682931 12.398L1.6025 13.3169L2.10957 12.8101C2.40528 13.0058 2.73582 13.1523 3.08855 13.2435V13.9998H4.71427V13.2431C5.05915 13.1543 5.38252 13.0116 5.67311 12.8228L6.20033 13.3496L7.1199 12.4308L6.60053 11.9111C6.8037 11.6095 6.9536 11.2705 7.04648 10.9092H7.80317V9.28826H7.04648C6.95599 8.9345 6.80984 8.6026 6.61316 8.3062ZM3.90158 11.4357C3.16299 11.4357 2.56406 10.8368 2.56406 10.0982C2.56406 9.35963 3.16299 8.76069 3.90158 8.76069C4.64017 8.76069 5.2391 9.35963 5.2391 10.0982C5.2391 10.8368 4.64017 11.4357 3.90158 11.4357Z' />
      <path d='M0 0V5.85511H1.36586V1.36586H10.6708V3.13738H11.8448V1.36586H15.0245V2.92807C13.8471 3.23163 12.9757 4.29768 12.9757 5.57032C12.9757 6.84297 13.8471 7.90902 15.0245 8.21224V9.56103H11.8448V7.72565H10.6708V9.56103H8.84976V10.9269H16.3903V8.21224V7.19229V6.93619H15.7074C14.9531 6.93619 14.3415 6.32462 14.3415 5.57032C14.3415 4.81603 14.9531 4.20446 15.7074 4.20446H16.3903V3.88417V2.92807V0H0Z' />
      <path d='M11.8376 4.40039H10.6708V6.52704H11.8376V4.40039Z' />
    </svg>
  ),
  checked: () => (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 3L4.5 8.5L2 6'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  approvalRequestNotification: (fill: string) => (
    <svg
      width='17'
      height='18'
      viewBox='0 0 17 18'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.45455 3.28628C4.49008 4.02746 3.09809 5.80456 3.098 7.89303V11.1767L1.21663 12.9055C1.08333 13.0222 1 13.1884 1 13.3728V13.4565C1 14.1622 1.61052 14.7343 2.36364 14.7343H5.79011C5.94373 16.0092 7.09839 17 8.5 17C9.90161 17 11.0563 16.0092 11.2099 14.7343H14.6364C15.3895 14.7343 16 14.1622 16 13.4565V13.3729C16.0001 13.1885 15.9168 13.0222 15.7834 12.9055L13.9022 11.1769V8.67822C15.105 8.4092 16 7.38603 16 6.16491C16 4.73866 14.7789 3.58246 13.2727 3.58246C12.7425 3.58246 12.2475 3.72576 11.8288 3.9737C11.44 3.69328 11.0086 3.46095 10.5455 3.28621V2.59726C10.5455 1.76479 9.86111 1.35456 9.59221 1.22855C9.24216 1.06448 8.85414 1 8.5 1C8.14586 1 7.75784 1.06448 7.4078 1.22855C7.13889 1.35456 6.45455 1.76479 6.45455 2.59726V3.28628ZM10.8885 4.9101C10.2211 4.46078 9.39632 4.19451 8.50007 4.19451C6.25716 4.19451 4.46174 5.86209 4.46163 7.89303V11.445C4.46163 11.6267 4.38114 11.7896 4.25246 11.9055L2.56466 13.4565H14.4354L12.9474 12.0892C12.6859 11.8489 12.5385 11.5201 12.5385 11.1769V8.65272C11.3889 8.34915 10.5455 7.35032 10.5455 6.16491C10.5455 5.70949 10.67 5.2816 10.8885 4.9101ZM9.13205 2.91671C9.1285 2.92773 9.12482 2.9386 9.121 2.9493C8.91714 2.92777 8.71 2.91671 8.50007 2.91671C8.29014 2.91671 8.08293 2.92778 7.87907 2.94932C7.87518 2.93861 7.8715 2.92774 7.86795 2.91671H7.81818V2.59726C7.81818 2.42084 8.12316 2.27781 8.5 2.27781C8.87684 2.27781 9.18182 2.42084 9.18182 2.59726V2.91671H9.13205ZM7.17161 14.7343C7.31173 15.3004 7.8533 15.7222 8.5 15.7222C9.1467 15.7222 9.68827 15.3004 9.82839 14.7343H7.17161ZM11.9091 6.16491C11.9091 5.45179 12.5196 4.87368 13.2727 4.87368C14.0259 4.87368 14.6364 5.45179 14.6364 6.16491C14.6364 6.87806 14.0259 7.45614 13.2727 7.45614C12.5196 7.45614 11.9091 6.87806 11.9091 6.16491Z'
        fill={fill}
        stroke={fill}
        strokeWidth='0.2'
      />
    </svg>
  ),
  strings: (fill: string) => (
    <svg
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 14H11V12H1V14ZM1 9H15V7H1V9ZM1 4H15V2H1V4Z'
        fill={fill}
      />
      <g clipPath='url(#clip0_340_16801)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11 16.7333V18H12.2667L15.9333 14.3L14.6667 13.0333L11 16.7333ZM16.9 13.3333C17.0333 13.2 17.0333 13 16.9 12.8667L16.1333 12.1C16 11.9667 15.8 11.9667 15.6667 12.1L15.0667 12.7L16.3333 13.9667L16.9 13.3333Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_340_16801'>
          <rect width='6' height='6' fill={fill} transform='translate(11 12)' />
        </clipPath>
      </defs>
    </svg>
  ),
  pages: (fill: string) => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.0909 0H4.72727C3.22104 0 2 1.22104 2 2.72727V17.2727C2 18.779 3.22104 20 4.72727 20H15.6364C17.1426 20 18.3636 18.779 18.3636 17.2727V7.27273C18.3636 7.23761 18.3616 7.20269 18.3576 7.16815L18.3575 7.16671C18.3336 6.96096 18.241 6.77616 18.1033 6.63585C18.1013 6.63386 18.0993 6.63188 18.0974 6.6299L11.734 0.266577L11.7337 0.266267C11.5632 0.0957789 11.332 0 11.0909 0ZM10.1818 1.81818H4.72727C4.2252 1.81818 3.81818 2.2252 3.81818 2.72727V17.2727C3.81818 17.7748 4.2252 18.1818 4.72727 18.1818H15.6364C16.1384 18.1818 16.5455 17.7748 16.5455 17.2727V8.18182H11.0909C10.6247 8.18182 10.2404 7.83087 10.1879 7.37875L10.1818 7.27273V1.81818ZM15.2591 6.36364L12 3.10455V6.36364H15.2591Z'
        fill={fill}
      />
      <mask
        id='mask0_340_16820'
        maskUnits='userSpaceOnUse'
        x='2'
        y='0'
        width='17'
        height='20'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.0909 0H4.72727C3.22104 0 2 1.22104 2 2.72727V17.2727C2 18.779 3.22104 20 4.72727 20H15.6364C17.1426 20 18.3636 18.779 18.3636 17.2727V7.27273C18.3636 7.23761 18.3616 7.20269 18.3576 7.16815L18.3575 7.16671C18.3336 6.96096 18.241 6.77616 18.1033 6.63585C18.1013 6.63386 18.0993 6.63188 18.0974 6.6299L11.734 0.266577L11.7337 0.266267C11.5632 0.0957789 11.332 0 11.0909 0ZM10.1818 1.81818H4.72727C4.2252 1.81818 3.81818 2.2252 3.81818 2.72727V17.2727C3.81818 17.7748 4.2252 18.1818 4.72727 18.1818H15.6364C16.1384 18.1818 16.5455 17.7748 16.5455 17.2727V8.18182H11.0909C10.6247 8.18182 10.2404 7.83087 10.1879 7.37875L10.1818 7.27273V1.81818ZM15.2591 6.36364L12 3.10455V6.36364H15.2591Z'
          fill={fill}
        />
      </mask>
      <g mask='url(#mask0_340_16820)'>
        <rect width='20' height='20' fill={fill} />
      </g>
    </svg>
  ),
  events: (fill: string) => (
    <svg
      width='21'
      height='20'
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.0051 0C9.50283 0 9.09564 0.407091 9.09564 0.909263V10.0019C9.09564 10.5041 9.50283 10.9111 10.0051 10.9111H19.0999C19.6022 10.9111 20.0093 10.5041 20.0093 10.0019C20.0093 7.34922 18.9553 4.8052 17.0792 2.92949C15.203 1.05377 12.6584 0 10.0051 0ZM10.9146 1.86944L11.1273 1.89576C12.8836 2.13875 14.5249 2.9476 15.793 4.21538L15.9894 4.41861C17.1446 5.6562 17.8829 7.21649 18.1131 8.88L18.1385 9.09262H10.9146V1.86944ZM7.20078 1.30028C6.99989 0.840025 6.46383 0.629733 6.00346 0.830582C1.8831 2.62822 -0.531863 6.95291 0.0997592 11.4029C0.731382 15.8529 4.25445 19.3351 8.71238 19.9157C13.1703 20.4963 17.4682 18.0327 19.219 13.893C19.4147 13.4305 19.1982 12.897 18.7356 12.7015C18.273 12.5059 17.7393 12.7223 17.5437 13.1848C16.1112 16.5718 12.5948 18.5875 8.94736 18.1124C5.29996 17.6374 2.41745 14.7883 1.90067 11.1474C1.38388 7.5065 3.35976 3.96812 6.73097 2.49732C7.19134 2.29647 7.40168 1.76054 7.20078 1.30028Z'
        fill={fill}
      />
      <mask
        id='mask0_340_16823'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='21'
        height='20'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.0051 0C9.50283 0 9.09564 0.407091 9.09564 0.909263V10.0019C9.09564 10.5041 9.50283 10.9111 10.0051 10.9111H19.0999C19.6022 10.9111 20.0093 10.5041 20.0093 10.0019C20.0093 7.34922 18.9553 4.8052 17.0792 2.92949C15.203 1.05377 12.6584 0 10.0051 0ZM10.9146 1.86944L11.1273 1.89576C12.8836 2.13875 14.5249 2.9476 15.793 4.21538L15.9894 4.41861C17.1446 5.6562 17.8829 7.21649 18.1131 8.88L18.1385 9.09262H10.9146V1.86944ZM7.20078 1.30028C6.99989 0.840025 6.46383 0.629733 6.00346 0.830582C1.8831 2.62822 -0.531863 6.95291 0.0997592 11.4029C0.731382 15.8529 4.25445 19.3351 8.71238 19.9157C13.1703 20.4963 17.4682 18.0327 19.219 13.893C19.4147 13.4305 19.1982 12.897 18.7356 12.7015C18.273 12.5059 17.7393 12.7223 17.5437 13.1848C16.1112 16.5718 12.5948 18.5875 8.94736 18.1124C5.29996 17.6374 2.41745 14.7883 1.90067 11.1474C1.38388 7.5065 3.35976 3.96812 6.73097 2.49732C7.19134 2.29647 7.40168 1.76054 7.20078 1.30028Z'
          fill={fill}
        />
      </mask>
      <g mask='url(#mask0_340_16823)'>
        <rect width='20.0047' height='20' fill={fill} />
      </g>
    </svg>
  ),
  faq: (fill: string) => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_202_4336)'>
        <path
          d='M10 0C4.48333 0 0 4.48333 0 10C0 15.5167 4.48333 20 10 20C15.5167 20 20 15.5167 20 10C20 4.48333 15.5167 0 10 0ZM10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.4 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.4 18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333Z'
          fill={fill}
        />
        <path
          d='M10.7166 4.24992C9.11656 3.84992 7.33322 4.86658 6.84989 6.43325C6.69989 6.88325 6.94989 7.34991 7.38322 7.48325C7.81656 7.61658 8.28322 7.38325 8.43322 6.93325C8.66656 6.19991 9.56656 5.68325 10.3332 5.86658C11.0832 6.04992 11.6499 6.93325 11.4999 7.69991C11.3666 8.46658 10.5499 9.08325 9.76656 8.98325C9.53322 8.94991 9.28322 9.03325 9.11656 9.18325C8.93322 9.34992 8.83322 9.56658 8.83322 9.81658L8.81656 12.4166C8.81656 12.8832 9.18322 13.2499 9.64989 13.2499C10.1166 13.2499 10.4832 12.8832 10.4832 12.4166L10.4999 10.5999C11.7832 10.3499 12.9166 9.29992 13.1499 7.98325C13.4499 6.36658 12.3332 4.64992 10.7166 4.24992Z'
          fill={fill}
        />
        <path
          d='M9.68301 13.9834H9.66634C9.21634 13.9834 8.84967 14.3667 8.83301 14.8167C8.83301 14.8334 8.83301 14.9834 8.83301 15.0001C8.83301 15.4501 9.19967 15.7501 9.64967 15.7667H9.66634C10.1163 15.7667 10.483 15.3501 10.4997 14.9001C10.4997 14.8834 10.4997 14.7834 10.4997 14.7667C10.483 14.3167 10.133 13.9834 9.68301 13.9834Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_202_4336'>
          <rect width='20' height='20' fill={fill} />
        </clipPath>
      </defs>
    </svg>
  ),
  tc: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.2 13.5992H14.4V3.19922H11.2V13.5992ZM1.6001 5.59922H9.6001V3.19922H1.6001V5.59922ZM1.6001 9.59922H9.6001V7.19922H1.6001V9.59922ZM1.6001 13.5992H9.6001V11.1992H1.6001V13.5992ZM0 15.1996H16V1.59961H0V15.1996Z'
      />
      <mask
        id='mask0_358_11661'
        style={{
          maskType: 'luminance',
        }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='1'
        width='16'
        height='15'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2 13.5992H14.4V3.19922H11.2V13.5992ZM1.6001 5.59922H9.6001V3.19922H1.6001V5.59922ZM1.6001 9.59922H9.6001V7.19922H1.6001V9.59922ZM1.6001 13.5992H9.6001V11.1992H1.6001V13.5992ZM0 15.1996H16V1.59961H0V15.1996Z'
        />
      </mask>
      <g mask='url(#mask0_358_11661)'>
        <rect width='16' height='16' />
      </g>
    </svg>
  ),
  user: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_492_11763)'>
        <path
          d='M11.3334 14V12.6667C11.3334 11.9594 11.0524 11.2811 10.5523 10.781C10.0522 10.281 9.37393 10 8.66669 10H3.33335C2.62611 10 1.94783 10.281 1.44774 10.781C0.947639 11.2811 0.666687 11.9594 0.666687 12.6667V14'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.99998 7.33333C7.47274 7.33333 8.66665 6.13943 8.66665 4.66667C8.66665 3.19391 7.47274 2 5.99998 2C4.52722 2 3.33331 3.19391 3.33331 4.66667C3.33331 6.13943 4.52722 7.33333 5.99998 7.33333Z'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.3333 14V12.6667C15.3329 12.0758 15.1362 11.5019 14.7742 11.0349C14.4122 10.5679 13.9054 10.2344 13.3333 10.0867'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.6667 2.08667C11.2403 2.23354 11.7487 2.56714 12.1118 3.03488C12.4748 3.50262 12.6719 4.07789 12.6719 4.67C12.6719 5.26212 12.4748 5.83739 12.1118 6.30513C11.7487 6.77287 11.2403 7.10647 10.6667 7.25334'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_492_11763'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  ),
  role: (fill: string) => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_492_11768)'>
        <path
          d='M10.4576 2.16099C10.293 1.45022 9.64057 0.961163 8.91214 1.00243C8.18371 1.04369 7.59072 1.6033 7.50736 2.32812C7.42401 3.05294 7.87449 3.73255 8.57454 3.93809C9.27458 4.14363 10.021 3.81542 10.3427 3.16059C12.2693 3.59888 13.8564 4.95794 14.586 6.79412L15.5006 6.43427C14.6408 4.25559 12.7479 2.65161 10.4576 2.16099ZM9.00323 3.00565C8.7272 3.00565 8.50343 2.78188 8.50343 2.50585C8.50343 2.22982 8.7272 2.00606 9.00323 2.00606C9.27926 2.00606 9.50303 2.22982 9.50303 2.50585C9.50303 2.63841 9.45037 2.76553 9.35664 2.85926C9.26291 2.95299 9.13578 3.00565 9.00323 3.00565ZM6.80412 3.42048L6.43427 2.50585C4.25559 3.36568 2.65161 5.25857 2.16099 7.54882C1.45022 7.71349 0.961163 8.36589 1.00243 9.09432C1.04369 9.82275 1.6033 10.4157 2.32812 10.4991C3.05294 10.5824 3.73255 10.132 3.93809 9.43192C4.14363 8.73187 3.81542 7.98549 3.16059 7.66377C3.6009 5.73497 4.96408 4.14739 6.80412 3.42048ZM2.50585 9.50303C2.22982 9.50303 2.00606 9.27926 2.00606 9.00323C2.00606 8.7272 2.22982 8.50343 2.50585 8.50343C2.78188 8.50343 3.00565 8.7272 3.00565 9.00323C3.00565 9.27926 2.78188 9.50303 2.50585 9.50303ZM9.00323 14.0012C8.43459 14.0029 7.91586 14.3262 7.66377 14.8359C5.73718 14.3976 4.15006 13.0385 3.42048 11.2023L2.50585 11.5722C3.36854 13.7547 5.26789 15.3594 7.56381 15.8455C7.74458 16.61 8.48489 17.1054 9.26062 16.9809C10.0364 16.8564 10.5844 16.1542 10.5168 15.3714C10.4492 14.5887 9.78882 13.9909 9.00323 14.0012ZM9.00323 16.0004C8.7272 16.0004 8.50343 15.7766 8.50343 15.5006C8.50343 15.2246 8.7272 15.0008 9.00323 15.0008C9.27926 15.0008 9.50303 15.2246 9.50303 15.5006C9.50303 15.7766 9.27926 16.0004 9.00323 16.0004ZM17 9.00323C17.0022 8.26286 16.4637 7.63169 15.7323 7.51731C15.0008 7.40292 14.2953 7.83956 14.0714 8.54527C13.8475 9.25097 14.1722 10.0145 14.8359 10.3427C14.3976 12.2693 13.0385 13.8564 11.2023 14.586L11.5722 15.5006C13.7547 14.6379 15.3594 12.7386 15.8455 10.4426C16.5149 10.2845 16.9909 9.69107 17 9.00323ZM15.5006 9.50303C15.2246 9.50303 15.0008 9.27926 15.0008 9.00323C15.0008 8.7272 15.2246 8.50343 15.5006 8.50343C15.7766 8.50343 16.0004 8.7272 16.0004 9.00323C16.0004 9.27926 15.7766 9.50303 15.5006 9.50303Z'
          fill='white'
          stroke={fill}
          strokeWidth='0.3'
        />
        <path
          d='M10.3976 8.93325C10.9791 8.36526 11.1588 7.50172 10.8522 6.7489C10.5455 5.99609 9.81358 5.50391 9.0007 5.50391C8.18783 5.50391 7.45588 5.99609 7.14923 6.7489C6.84257 7.50172 7.02226 8.36526 7.60377 8.93325C6.91657 9.39775 6.50462 10.173 6.50421 11.0024V12.002H11.5022V11.0024C11.5007 10.172 11.0867 9.39661 10.3976 8.93325ZM8.0036 7.50383C8.0036 6.95177 8.45114 6.50423 9.0032 6.50423C9.55526 6.50423 10.0028 6.95177 10.0028 7.50383C10.0028 8.05589 9.55526 8.50343 9.0032 8.50343C8.45114 8.50343 8.0036 8.05589 8.0036 7.50383ZM7.50381 11.0024C7.50381 10.1743 8.17511 9.50302 9.0032 9.50302C9.83129 9.50302 10.5026 10.1743 10.5026 11.0024H7.50381Z'
          fill='white'
          stroke={fill}
          strokeWidth='0.3'
        />
      </g>
      <defs>
        <clipPath id='clip0_492_11768'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  ),
  profile: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.99999 0C5.79085 0 3.99999 1.79086 3.99999 4C3.99999 6.20914 5.79085 8 7.99999 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 7.99999 0ZM7.99999 1.6C9.32547 1.6 10.4 2.67452 10.4 4C10.4 5.32548 9.32547 6.4 7.99999 6.4C6.6745 6.4 5.59999 5.32548 5.59999 4C5.59999 2.67452 6.6745 1.6 7.99999 1.6ZM15.1963 13.4265C15.1054 11.2978 13.351 9.6 11.2 9.6H4.79999L4.62648 9.6037C2.49783 9.69455 0.799988 11.449 0.799988 13.6V15.2L0.80537 15.2933C0.851582 15.6912 1.18972 16 1.59999 16C2.04182 16 2.39999 15.6418 2.39999 15.2V13.6L2.40406 13.459C2.47706 12.1991 3.52184 11.2 4.79999 11.2H11.2L11.341 11.2041C12.6009 11.2771 13.6 12.3219 13.6 13.6V15.2L13.6054 15.2933C13.6516 15.6912 13.9897 16 14.4 16C14.8418 16 15.2 15.6418 15.2 15.2V13.6L15.1963 13.4265Z'
      />
      <mask
        id='mask0_428_12338'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.99999 0C5.79085 0 3.99999 1.79086 3.99999 4C3.99999 6.20914 5.79085 8 7.99999 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 7.99999 0ZM7.99999 1.6C9.32547 1.6 10.4 2.67452 10.4 4C10.4 5.32548 9.32547 6.4 7.99999 6.4C6.6745 6.4 5.59999 5.32548 5.59999 4C5.59999 2.67452 6.6745 1.6 7.99999 1.6ZM15.1963 13.4265C15.1054 11.2978 13.351 9.6 11.2 9.6H4.79999L4.62648 9.6037C2.49783 9.69455 0.799988 11.449 0.799988 13.6V15.2L0.80537 15.2933C0.851582 15.6912 1.18972 16 1.59999 16C2.04182 16 2.39999 15.6418 2.39999 15.2V13.6L2.40406 13.459C2.47706 12.1991 3.52184 11.2 4.79999 11.2H11.2L11.341 11.2041C12.6009 11.2771 13.6 12.3219 13.6 13.6V15.2L13.6054 15.2933C13.6516 15.6912 13.9897 16 14.4 16C14.8418 16 15.2 15.6418 15.2 15.2V13.6L15.1963 13.4265Z'
        />
      </mask>
      <g mask='url(#mask0_428_12338)'>
        <rect width='16' height='16' />
      </g>
    </svg>
  ),
  logout: (fill: string) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.7191 0.916C11.1215 0.6016 10.3999 1.0224 10.3999 1.6984C10.3999 2.0416 10.6047 2.34 10.9079 2.5008C13.1327 3.6816 14.5607 6.1728 14.1527 8.9392C13.7495 11.6816 11.4671 13.8744 8.71186 14.1824C4.96386 14.6008 1.77826 11.6648 1.77826 8C1.77826 5.6032 3.13986 3.52 5.13026 2.4808C5.41106 2.3344 5.59986 2.0576 5.59986 1.7408V1.6672C5.59986 1.0048 4.89426 0.596 4.30626 0.9032C1.48706 2.3728 -0.346541 5.4728 0.0550587 8.9528C0.475859 12.5936 3.44066 15.544 7.08306 15.9488C11.9119 16.4856 15.9999 12.72 15.9999 8C15.9999 4.924 14.2647 2.2544 11.7191 0.916ZM7.19986 7.2V0.8C7.19986 0.3576 7.55826 0 7.99986 0C8.44226 0 8.79986 0.3576 8.79986 0.8V7.2C8.79986 7.6416 8.44226 8 7.99986 8C7.55826 8 7.19986 7.6416 7.19986 7.2Z'
      />
      <mask
        id='mask0_428_12335'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.7191 0.916C11.1215 0.6016 10.3999 1.0224 10.3999 1.6984C10.3999 2.0416 10.6047 2.34 10.9079 2.5008C13.1327 3.6816 14.5607 6.1728 14.1527 8.9392C13.7495 11.6816 11.4671 13.8744 8.71186 14.1824C4.96386 14.6008 1.77826 11.6648 1.77826 8C1.77826 5.6032 3.13986 3.52 5.13026 2.4808C5.41106 2.3344 5.59986 2.0576 5.59986 1.7408V1.6672C5.59986 1.0048 4.89426 0.596 4.30626 0.9032C1.48706 2.3728 -0.346541 5.4728 0.0550587 8.9528C0.475859 12.5936 3.44066 15.544 7.08306 15.9488C11.9119 16.4856 15.9999 12.72 15.9999 8C15.9999 4.924 14.2647 2.2544 11.7191 0.916ZM7.19986 7.2V0.8C7.19986 0.3576 7.55826 0 7.99986 0C8.44226 0 8.79986 0.3576 8.79986 0.8V7.2C8.79986 7.6416 8.44226 8 7.99986 8C7.55826 8 7.19986 7.6416 7.19986 7.2Z'
        />
      </mask>
      <g mask='url(#mask0_428_12335)'>
        <rect width='16' height='16' />
      </g>
    </svg>
  ),
  remove: (fill = '#343944') => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.60714 4C3.71954 4 3 4.74619 3 5.66667V6.33333C3 7.25381 3.71954 8 4.60714 8H19.3929C20.2805 8 21 7.25381 21 6.33333V5.66667C21 4.74619 20.2805 4 19.3929 4H4.60714Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.36011 9.33333L4.82277 17.4899C4.90272 18.8994 6.02825 20 7.38976 20H16.61C17.9715 20 19.097 18.8994 19.177 17.4899L19.6396 9.33333H4.36011ZM9.61686 11.8619C9.86791 11.6016 10.2749 11.6016 10.526 11.8619L12 13.3905L13.474 11.8619C13.7251 11.6016 14.1321 11.6016 14.3831 11.8619C14.6342 12.1223 14.6342 12.5444 14.3831 12.8047L12.9091 14.3333L14.3831 15.8619C14.6342 16.1223 14.6342 16.5444 14.3831 16.8047C14.1321 17.0651 13.7251 17.0651 13.474 16.8047L12 15.2761L10.526 16.8047C10.2749 17.0651 9.86791 17.0651 9.61686 16.8047C9.36581 16.5444 9.36581 16.1223 9.61686 15.8619L11.0909 14.3333L9.61686 12.8047C9.36581 12.5444 9.36581 12.1223 9.61686 11.8619Z'
        fill={fill}
      />
    </svg>
  ),
  infoIcon: (color = '#343944', size = '24') => (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2ZM3.39535 12C3.39535 7.24779 7.24779 3.39535 12 3.39535C16.7522 3.39535 20.6047 7.24779 20.6047 12C20.6047 16.7522 16.7522 20.6047 12 20.6047C7.24779 20.6047 3.39535 16.7522 3.39535 12ZM12.6977 11.0698C12.6977 10.6845 12.3853 10.3721 12 10.3721C11.6147 10.3721 11.3023 10.6845 11.3023 11.0698V16.6512C11.3023 17.0365 11.6147 17.3488 12 17.3488C12.3853 17.3488 12.6977 17.0365 12.6977 16.6512V11.0698ZM12 9.2093C12.5138 9.2093 12.9302 8.79282 12.9302 8.27907C12.9302 7.76532 12.5138 7.34884 12 7.34884C11.4862 7.34884 11.0698 7.76532 11.0698 8.27907C11.0698 8.79282 11.4862 9.2093 12 9.2093Z'
        fill={color}
      />
    </svg>
  ),
  eyeIcon: (color = 'black') => {
    return (
      <svg
        width='17'
        height='17'
        viewBox='0 0 17 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.169922 8.49989C0.952935 6.96395 2.14536 5.67441 3.61542 4.77377C5.08547 3.87314 6.77591 3.39648 8.49992 3.39648C10.2239 3.39648 11.9144 3.87314 13.3844 4.77377C14.8545 5.67441 16.0469 6.96395 16.8299 8.49989C16.0469 10.0358 14.8545 11.3254 13.3844 12.226C11.9144 13.1266 10.2239 13.6033 8.49992 13.6033C6.77591 13.6033 5.08547 13.1266 3.61542 12.226C2.14536 11.3254 0.952935 10.0358 0.169922 8.49989ZM8.49992 11.8999C9.40166 11.8999 10.2665 11.5417 10.9041 10.904C11.5417 10.2664 11.8999 9.40162 11.8999 8.49989C11.8999 7.59815 11.5417 6.73335 10.9041 6.09572C10.2665 5.4581 9.40166 5.09989 8.49992 5.09989C7.59819 5.09989 6.73338 5.4581 6.09576 6.09572C5.45814 6.73335 5.09992 7.59815 5.09992 8.49989C5.09992 9.40162 5.45814 10.2664 6.09576 10.904C6.73338 11.5417 7.59819 11.8999 8.49992 11.8999ZM8.49992 10.1999C8.04905 10.1999 7.61665 10.0208 7.29784 9.70197C6.97903 9.38315 6.79992 8.95075 6.79992 8.49989C6.79992 8.04902 6.97903 7.61662 7.29784 7.2978C7.61665 6.97899 8.04905 6.79989 8.49992 6.79989C8.95079 6.79989 9.38319 6.97899 9.702 7.2978C10.0208 7.61662 10.1999 8.04902 10.1999 8.49989C10.1999 8.95075 10.0208 9.38315 9.702 9.70197C9.38319 10.0208 8.95079 10.1999 8.49992 10.1999Z'
          fill={color}
        />
      </svg>
    );
  },
  leftArrow: () => {
    return (
      <svg
        width='5'
        height='8'
        viewBox='0 0 5 8'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.97949 0.159096L0.175091 3.61591C-0.0583647 3.82804 -0.0583646 4.17196 0.175092 4.38409L3.97949 7.8409C4.21294 8.05303 4.59145 8.05303 4.82491 7.8409C5.05837 7.62878 5.05837 7.28485 4.82491 7.07272L1.44322 4L4.82491 0.927276C5.05836 0.715149 5.05836 0.371223 4.82491 0.159096C4.59145 -0.0530318 4.21294 -0.0530317 3.97949 0.159096Z'
          fill='white'
        />
      </svg>
    );
  },
  upArrow: (bgColor = 'white') => {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          x='16'
          y='16'
          width='16'
          height='16'
          rx='1'
          transform='rotate(-180 16 16)'
          fill={bgColor}
        />
        <path
          d='M7.70618 6.31807C7.86455 6.14663 8.13545 6.14663 8.29382 6.31807L10.8439 9.07858C11.0805 9.33477 10.8988 9.75 10.55 9.75L5.44995 9.75C5.10118 9.75 4.91947 9.33477 5.15613 9.07858L7.70618 6.31807Z'
          fill='#4B5057'
        />
      </svg>
    );
  },
  downArrow: (bgColor = 'white') => {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect width='16' height='16' rx='1' fill={bgColor} />
        <path
          d='M8.29382 9.68193C8.13545 9.85337 7.86455 9.85337 7.70618 9.68193L5.15613 6.92142C4.91947 6.66523 5.10118 6.25 5.44995 6.25L10.55 6.25C10.8988 6.25 11.0805 6.66523 10.8439 6.92142L8.29382 9.68193Z'
          fill='#4B5057'
        />
      </svg>
    );
  },
  selectArrow: (bgColor = 'white') => {
    return (
      <svg
        width='10'
        height='6'
        viewBox='0 0 10 6'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.30237 5.65085C5.14286 5.83504 4.85714 5.83504 4.69763 5.65085L0.377038 0.66186C0.152687 0.402802 0.336709 -9.32215e-07 0.67941 -9.02255e-07L9.32059 -1.46819e-07C9.66329 -1.16859e-07 9.84731 0.402804 9.62296 0.661861L5.30237 5.65085Z'
          fill={bgColor}
        />
      </svg>
    );
  },
  arrowPointer: (color = '#1167B1') => {
    return (
      <svg
        width='13.18px'
        height='12.61px'
        viewBox='0 0 14 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_3209_14939)'>
          <path
            d='M12.0921 2.59668H12.8777V7.31006L7.52982 12.6579L6.80469 11.9328'
            stroke={color}
            strokeWidth='0.906419'
            strokeMiterlimit='10'
          />
          <path
            d='M6.23228 1.08594L0.703125 6.61509L5.26543 11.1774L10.7644 5.67846V1.14637L6.23228 1.08594Z'
            stroke={color}
            strokeWidth='0.785563'
            strokeMiterlimit='10'
          />
          <path
            d='M8.77041 3.68438C9.07077 3.68438 9.31427 3.44089 9.31427 3.14053C9.31427 2.84017 9.07077 2.59668 8.77041 2.59668C8.47005 2.59668 8.22656 2.84017 8.22656 3.14053C8.22656 3.44089 8.47005 3.68438 8.77041 3.68438Z'
            fill={color}
          />
        </g>
        <defs>
          <clipPath id='clip0_3209_14939'>
            <rect
              width='13.1849'
              height='12.6078'
              fill='white'
              transform='translate(0.146484 0.691406)'
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  calendarIcon: () => {
    return (
      <svg
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M5.49348 2.75227V3.66518H2.74653C2.24019 3.6672 1.83133 4.0791 1.83327 4.58525V19.2455C1.83033 19.7523 2.23949 20.1653 2.74653 20.1673H19.2461C19.756 20.1692 20.1695 19.7551 20.1666 19.2455V4.58525C20.1685 4.07631 19.7553 3.66324 19.2461 3.66518H16.4992V2.75227C16.4833 1.52091 14.6506 1.53488 14.6637 2.75227V3.66518H7.32717V2.75227C7.32906 1.52701 5.49573 1.52879 5.49348 2.75227ZM3.66696 5.49815H5.49348V6.42001C5.49348 7.6464 7.32717 7.62899 7.32717 6.42001V5.49815H14.6637V6.42001C14.6637 7.65737 16.4992 7.62821 16.4992 6.42001V5.49815H18.3329V8.25298H3.66696V5.49815ZM3.66696 10.0788H18.3329V18.3325H3.66696V10.0788ZM5.49348 10.9989C4.35027 10.9989 4.27713 12.8336 5.49348 12.8336H7.32717C8.57578 12.8356 8.60451 11.0026 7.32717 10.9989H5.49348ZM10.0831 10.9989C8.86224 11.0024 8.83355 12.8356 10.0831 12.8336H11.9168C13.1448 12.8356 13.2164 11.0027 11.9168 10.9989H10.0831ZM14.6637 10.9989C13.4599 11.0024 13.4455 12.8355 14.6637 12.8336H16.4992C17.7146 12.8336 17.7854 11.0027 16.4992 10.9989H14.6637ZM5.49348 14.6666C4.29597 14.6666 4.29597 16.4996 5.49348 16.4996H7.32717C8.52998 16.5029 8.57053 14.6693 7.32717 14.6666H5.49348ZM10.0831 14.6666C8.81733 14.6666 8.83892 16.4996 10.0831 16.4996H11.9168C13.093 16.5029 13.1134 14.6666 11.9168 14.6666H10.0831ZM14.6637 14.6666C13.4425 14.6693 13.4424 16.4996 14.6637 16.4996H16.4992C17.7135 16.503 17.7598 14.6693 16.4992 14.6666H14.6637Z'
          fill='#B7B7B7'
        />
      </svg>
    );
  },
  rightArrow: () => {
    return (
      <svg
        width='5'
        height='8'
        viewBox='0 0 5 8'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.02051 0.159096L4.82491 3.61591C5.05836 3.82804 5.05836 4.17196 4.82491 4.38409L1.02051 7.8409C0.787056 8.05303 0.408548 8.05303 0.175091 7.8409C-0.0583655 7.62878 -0.0583654 7.28485 0.175091 7.07272L3.55678 4L0.175092 0.927276C-0.0583643 0.715149 -0.0583642 0.371223 0.175092 0.159096C0.408549 -0.0530318 0.787057 -0.0530317 1.02051 0.159096Z'
          fill='white'
        />
      </svg>
    );
  },
  closeIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        className='h-6 w-6'
        fill='none'
        viewBox='0 0 24 24'
        stroke='currentColor'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M6 18L18 6M6 6l12 12'
        />
      </svg>
    );
  },
  logo: ({ width = '310', height = '50' }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 210 30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M36.302 23.2137C36.1252 22.9766 36.0663 22.6801 36.0663 22.3244C36.0663 21.9687 36.302 21.613 36.7145 21.3759C37.0092 21.1981 37.2449 21.1388 37.5396 21.1388C37.8342 21.1388 38.1289 21.3166 38.4236 21.613C38.895 22.0873 39.4254 22.5023 39.9558 22.7394C40.4862 23.0358 41.1344 23.1544 41.9595 23.1544C42.1952 23.1544 42.4899 23.0951 42.7845 23.0358C43.0792 22.9766 43.3738 22.858 43.5506 22.6209C43.7864 22.3837 43.9042 22.0873 43.9042 21.6723C43.9042 21.3166 43.7864 21.0202 43.5506 20.7831C43.3149 20.546 42.9613 20.3681 42.5488 20.2495C42.1363 20.0717 41.6648 19.9531 41.1934 19.8346C40.663 19.6567 40.1326 19.5381 39.6022 19.3603C39.0718 19.1824 38.5414 18.9453 38.1289 18.6489C37.6574 18.3525 37.3039 17.9375 37.0092 17.4632C36.7145 16.989 36.5967 16.3369 36.5967 15.6255C36.5967 14.7955 36.8324 14.0841 37.3039 13.4913C37.7753 12.8984 38.3646 12.4242 39.1307 12.1278C39.8969 11.8314 40.663 11.6535 41.488 11.6535C42.0184 11.6535 42.5488 11.7128 43.1381 11.8314C43.7274 11.9499 44.2578 12.1871 44.7882 12.4242C45.3186 12.7206 45.7311 13.0763 46.0847 13.4913C46.2615 13.7284 46.3794 14.0248 46.4383 14.3805C46.4972 14.7362 46.3204 15.0326 45.9668 15.329C45.7311 15.5069 45.4364 15.6255 45.0829 15.5662C44.7293 15.5662 44.4935 15.4476 44.2578 15.2105C43.9632 14.8548 43.6096 14.5584 43.1381 14.3212C42.6667 14.0841 42.1363 13.9655 41.488 13.9655C41.2523 13.9655 40.9576 13.9655 40.663 14.0248C40.3683 14.0841 40.1326 14.2027 39.8969 14.3805C39.6611 14.5584 39.5433 14.8548 39.5433 15.2698C39.5433 15.6847 39.6611 15.9812 39.8969 16.159C40.1326 16.3961 40.4862 16.574 40.8987 16.6926C41.3112 16.8111 41.7827 16.989 42.2541 17.1075C42.7256 17.2261 43.256 17.404 43.7864 17.5818C44.3167 17.7597 44.7882 17.9968 45.2007 18.2932C45.6132 18.5896 45.9668 19.0046 46.2615 19.4789C46.5562 19.9531 46.674 20.546 46.674 21.3166C46.674 22.1466 46.4383 22.9173 45.9079 23.5101C45.3775 24.1029 44.7882 24.5772 44.0221 24.8736C43.256 25.17 42.4899 25.3479 41.7237 25.3479C40.7219 25.3479 39.779 25.17 38.7771 24.8143C37.7753 24.6958 36.9503 24.1029 36.302 23.2137Z'
          fill='#00C389'
        />
        <path
          d='M60.0516 11.5942C60.4641 11.5942 60.8177 11.7128 61.1124 12.0092C61.407 12.3056 61.5249 12.6613 61.5249 13.1356V23.8065C61.5249 24.2215 61.407 24.6365 61.1124 24.8736C60.8177 25.17 60.4641 25.2886 60.0516 25.2886C59.6391 25.2886 59.2855 25.17 58.9908 24.8736C58.6962 24.5772 58.5783 24.2215 58.5783 23.8065V22.5616L59.1087 22.7987C59.1087 23.0358 58.9908 23.273 58.7551 23.5694C58.5194 23.8658 58.2247 24.1622 57.8122 24.4586C57.3997 24.7551 56.9282 24.9922 56.3978 25.2293C55.8674 25.4664 55.2781 25.5257 54.6299 25.5257C53.4512 25.5257 52.4494 25.2293 51.5065 24.6365C50.5636 24.0437 49.8564 23.2137 49.2671 22.1466C48.7367 21.0795 48.442 19.8938 48.442 18.5303C48.442 17.1668 48.7367 15.9219 49.2671 14.9141C49.7975 13.847 50.5636 13.017 51.4475 12.4242C52.3905 11.8314 53.3923 11.5349 54.512 11.5349C55.2192 11.5349 55.8674 11.6535 56.5157 11.8906C57.105 12.1278 57.6354 12.3649 58.1068 12.7206C58.5194 13.0763 58.873 13.3727 59.1087 13.7284C59.3444 14.0841 59.4623 14.3805 59.4623 14.6177L58.5783 14.9734V13.1356C58.5783 12.7206 58.6962 12.3056 58.9908 12.0685C59.2855 11.7721 59.6391 11.5942 60.0516 11.5942ZM54.9835 22.7987C55.6906 22.7987 56.3389 22.6209 56.9282 22.2652C57.4586 21.9095 57.93 21.3759 58.2247 20.7831C58.5194 20.131 58.6962 19.4196 58.6962 18.6489C58.6962 17.8189 58.5194 17.1075 58.2247 16.5147C57.93 15.8626 57.4586 15.3883 56.9282 15.0326C56.3978 14.6769 55.7496 14.4991 54.9835 14.4991C54.2763 14.4991 53.628 14.6769 53.0976 15.0326C52.5672 15.3883 52.0958 15.9219 51.8011 16.5147C51.5065 17.1668 51.3297 17.8782 51.3297 18.6489C51.3297 19.4196 51.5065 20.131 51.8011 20.7831C52.0958 21.4352 52.5672 21.9095 53.0976 22.2652C53.687 22.6209 54.2763 22.7987 54.9835 22.7987Z'
          fill='#00C389'
        />
        <path
          d='M64.9429 11.8314C65.2376 11.8314 65.5322 11.8906 65.8269 12.0685C66.1216 12.2463 66.2984 12.4835 66.4162 12.7799L70.07 21.2574L69.5396 21.4945L73.3113 12.8392C73.6059 12.1871 74.0184 11.8314 74.6078 11.8906C75.0203 11.8906 75.3739 12.0092 75.6096 12.3056C75.8453 12.5428 76.0221 12.8985 76.0221 13.2542C76.0221 13.3727 76.0221 13.4913 75.9632 13.6099C75.9043 13.7284 75.9043 13.847 75.8453 13.9655L71.1897 24.3401C70.895 24.9329 70.4825 25.2886 69.8932 25.2886C69.5985 25.3479 69.245 25.2886 69.0092 25.1108C68.7146 24.9329 68.4788 24.6958 68.361 24.3401L63.7054 13.9655C63.6464 13.9063 63.6464 13.7877 63.5875 13.6099C63.5286 13.4913 63.5286 13.3134 63.5286 13.1356C63.5286 12.8392 63.6464 12.5428 63.9411 12.2463C64.1179 12.0092 64.4715 11.8314 64.9429 11.8314Z'
          fill='#00C389'
        />
        <path
          d='M83.6832 25.585C82.2688 25.585 81.0313 25.2886 79.9705 24.6958C78.9097 24.1029 78.1436 23.273 77.5543 22.2652C77.0239 21.2573 76.7292 20.0717 76.7292 18.7675C76.7292 17.2854 77.0239 15.9812 77.6132 14.9141C78.2025 13.847 79.0276 13.017 80.0294 12.4835C81.0313 11.8906 82.0331 11.6535 83.1528 11.6535C83.9779 11.6535 84.8029 11.8314 85.569 12.1871C86.3351 12.5427 86.9834 13.017 87.5727 13.6098C88.162 14.2027 88.6335 14.9141 88.9871 15.744C89.3407 16.574 89.5175 17.404 89.5175 18.2932C89.5175 18.7082 89.3407 19.0046 89.046 19.301C88.7514 19.5381 88.3978 19.6567 87.9852 19.6567H78.4383L77.6722 17.1668H86.8655L86.3351 17.6411V16.989C86.2762 16.5147 86.1584 16.0404 85.8048 15.6847C85.5101 15.2698 85.0976 14.9734 84.6261 14.7955C84.1547 14.5584 83.6832 14.4398 83.1528 14.4398C82.6814 14.4398 82.2099 14.4991 81.7385 14.6177C81.3259 14.7362 80.9134 14.9734 80.6188 15.2698C80.3241 15.5662 80.0294 16.0404 79.8526 16.574C79.6758 17.1075 79.558 17.8189 79.558 18.5896C79.558 19.4789 79.7348 20.2495 80.1473 20.9017C80.5009 21.5538 81.0313 22.028 81.6206 22.3244C82.2099 22.6801 82.8582 22.7987 83.5064 22.7987C84.0957 22.7987 84.6261 22.7394 84.9797 22.6209C85.3333 22.5023 85.628 22.3837 85.8637 22.2652C86.0994 22.1466 86.2762 22.028 86.453 21.9095C86.7477 21.7316 87.0423 21.6723 87.2781 21.6723C87.6316 21.6723 87.9263 21.7909 88.162 22.028C88.3978 22.2652 88.5156 22.5616 88.5156 22.9173C88.5156 23.3915 88.2799 23.8065 87.8084 24.1622C87.3959 24.5179 86.7477 24.8736 85.9816 25.1107C85.3333 25.4072 84.5083 25.585 83.6832 25.585Z'
          fill='#00C389'
        />
        <path
          d='M93.1123 25.3479C92.6998 25.3479 92.3462 25.2293 92.0516 24.9329C91.7569 24.6365 91.639 24.2808 91.639 23.8658V13.3727C91.639 12.9577 91.7569 12.5428 92.0516 12.3056C92.3462 12.0092 92.6998 11.8907 93.1123 11.8907C93.5249 11.8907 93.8784 12.0092 94.1731 12.3056C94.4678 12.602 94.5856 12.9577 94.5856 13.3727V15.744L94.4088 14.0841C94.5856 13.6691 94.8214 13.3134 95.116 13.017C95.4107 12.7206 95.7643 12.4242 96.1179 12.2464C96.4715 12.0092 96.884 11.8907 97.2965 11.7721C97.709 11.6535 98.1215 11.5942 98.5341 11.5942C99.0055 11.5942 99.477 11.7128 99.7716 12.0092C100.125 12.3056 100.302 12.602 100.302 13.017C100.302 13.5506 100.184 13.9656 99.8895 14.2027C99.5948 14.4398 99.3002 14.5584 98.9466 14.5584C98.6519 14.5584 98.3573 14.4991 98.0626 14.3805C97.8269 14.262 97.5322 14.2027 97.1786 14.2027C96.884 14.2027 96.5893 14.262 96.2947 14.4398C96 14.5584 95.7053 14.7955 95.4696 15.0919C95.2339 15.3884 94.9982 15.744 94.8214 16.2183C94.6446 16.6333 94.5856 17.1668 94.5856 17.819V23.8065C94.5856 24.2215 94.4678 24.6365 94.1731 24.8736C93.9374 25.17 93.5838 25.3479 93.1123 25.3479Z'
          fill='#00C389'
        />
        <path
          d='M101.186 23.2137C101.009 22.9766 100.95 22.6801 100.95 22.3244C100.95 21.9687 101.186 21.613 101.599 21.3759C101.893 21.1981 102.129 21.1388 102.424 21.1388C102.718 21.1388 103.013 21.3166 103.308 21.613C103.779 22.0873 104.309 22.5023 104.84 22.7394C105.37 23.0358 106.018 23.1544 106.843 23.1544C107.079 23.1544 107.374 23.0951 107.668 23.0358C107.963 22.9766 108.258 22.858 108.435 22.6209C108.67 22.3837 108.788 22.0873 108.788 21.6723C108.788 21.3166 108.67 21.0202 108.435 20.7831C108.199 20.546 107.845 20.3681 107.433 20.2495C107.02 20.0717 106.549 19.9531 106.077 19.8346C105.547 19.6567 105.017 19.5381 104.486 19.3603C103.956 19.1824 103.425 18.9453 103.013 18.6489C102.541 18.3525 102.188 17.9375 101.893 17.4632C101.599 16.989 101.481 16.3369 101.481 15.6255C101.481 14.7955 101.716 14.0841 102.188 13.4913C102.659 12.8984 103.249 12.4242 104.015 12.1278C104.781 11.8314 105.547 11.6535 106.372 11.6535C106.902 11.6535 107.433 11.7128 108.022 11.8314C108.611 11.9499 109.142 12.1871 109.672 12.4242C110.203 12.7206 110.615 13.0763 110.969 13.4913C111.145 13.7284 111.263 14.0248 111.322 14.3805C111.381 14.7362 111.204 15.0326 110.851 15.329C110.615 15.5069 110.32 15.6255 109.967 15.5662C109.613 15.5662 109.378 15.4476 109.142 15.2105C108.847 14.8548 108.494 14.5584 108.022 14.3212C107.551 14.0841 107.02 13.9655 106.372 13.9655C106.136 13.9655 105.842 13.9655 105.547 14.0248C105.252 14.0841 105.017 14.2027 104.781 14.3805C104.545 14.5584 104.427 14.8548 104.427 15.2698C104.427 15.6847 104.545 15.9812 104.781 16.159C105.017 16.3961 105.37 16.574 105.783 16.6926C106.195 16.8111 106.667 16.989 107.138 17.1075C107.61 17.2261 108.14 17.404 108.67 17.5818C109.201 17.7597 109.672 17.9968 110.085 18.2932C110.497 18.5896 110.851 19.0046 111.145 19.4789C111.44 19.9531 111.558 20.546 111.558 21.3166C111.558 22.1466 111.322 22.9173 110.792 23.5101C110.261 24.1029 109.672 24.5772 108.906 24.8736C108.14 25.17 107.374 25.3479 106.608 25.3479C105.606 25.3479 104.663 25.17 103.661 24.8143C102.659 24.6958 101.834 24.1029 101.186 23.2137Z'
          fill='#00C389'
        />
        <path
          d='M120.516 11.5942C121.459 11.5942 122.284 11.7128 122.991 11.8907C123.698 12.0685 124.228 12.3649 124.641 12.7206C125.053 13.0763 125.23 13.4913 125.23 14.0248C125.23 14.3805 125.112 14.677 124.936 14.9734C124.759 15.2698 124.464 15.3884 124.052 15.3884C123.757 15.3884 123.58 15.3291 123.403 15.2698C123.227 15.2105 123.05 15.0919 122.932 14.9734C122.814 14.8548 122.637 14.7362 122.46 14.6177C122.284 14.4991 122.048 14.4398 121.694 14.3805C121.341 14.3213 121.105 14.3213 120.928 14.3213C120.103 14.3213 119.337 14.4991 118.748 14.8548C118.158 15.2105 117.687 15.744 117.392 16.3369C117.098 16.989 116.921 17.7004 116.921 18.5304C116.921 19.3603 117.098 20.0717 117.392 20.6645C117.687 21.2574 118.158 21.7909 118.748 22.1466C119.337 22.5023 119.985 22.6802 120.751 22.6802C121.164 22.6802 121.518 22.6802 121.812 22.6209C122.107 22.5616 122.343 22.5023 122.578 22.3837C122.814 22.2652 122.991 22.0873 123.227 21.9688C123.403 21.7909 123.698 21.7316 124.052 21.7316C124.464 21.7316 124.818 21.8502 125.053 22.1466C125.289 22.443 125.407 22.7394 125.407 23.1544C125.407 23.5694 125.171 23.9844 124.7 24.2808C124.228 24.6365 123.639 24.8736 122.873 25.1108C122.107 25.3479 121.282 25.4072 120.398 25.4072C119.101 25.4072 117.923 25.1108 116.98 24.5179C116.037 23.9251 115.271 23.0951 114.74 22.028C114.21 20.961 113.974 19.7753 113.974 18.4711C113.974 17.1076 114.269 15.8626 114.799 14.8548C115.33 13.7877 116.155 12.9577 117.098 12.3649C118.041 11.8907 119.219 11.5942 120.516 11.5942Z'
          fill='#1133BB'
        />
        <path
          d='M130.77 23.8065C130.77 24.2215 130.652 24.6365 130.357 24.8736C130.063 25.17 129.709 25.2886 129.297 25.2886C128.884 25.2886 128.53 25.17 128.236 24.8736C127.941 24.5772 127.823 24.2215 127.823 23.8065V8.21511C127.823 7.80013 127.941 7.38515 128.236 7.14801C128.53 6.8516 128.884 6.73303 129.297 6.73303C129.709 6.73303 130.063 6.8516 130.357 7.14801C130.652 7.44443 130.77 7.80013 130.77 8.21511V23.8065Z'
          fill='#1133BB'
        />
        <path
          d='M143.204 11.8314C143.617 11.8314 143.971 11.9499 144.265 12.2463C144.56 12.5428 144.678 12.8985 144.678 13.3134V19.716C144.678 21.4945 144.206 22.9173 143.204 23.9251C142.203 24.9922 140.788 25.4665 138.961 25.4665C137.134 25.4665 135.72 24.9329 134.718 23.9251C133.716 22.858 133.245 21.4945 133.245 19.716V13.3727C133.245 12.9577 133.363 12.5428 133.657 12.3056C133.952 12.0092 134.306 11.8906 134.718 11.8906C135.131 11.8906 135.484 12.0092 135.779 12.3056C136.074 12.602 136.192 12.9577 136.192 13.3727V19.7753C136.192 20.7831 136.427 21.5538 136.84 22.028C137.311 22.5023 137.959 22.7987 138.843 22.7987C139.786 22.7987 140.435 22.5616 140.906 22.028C141.378 21.5538 141.554 20.7831 141.554 19.7753V13.3727C141.554 12.9577 141.672 12.5428 141.967 12.3056C142.438 12.0092 142.792 11.8314 143.204 11.8314Z'
          fill='#1133BB'
        />
        <path
          d='M153.871 11.5942C155.05 11.5942 156.111 11.8907 156.994 12.4835C157.937 13.0763 158.645 13.9063 159.175 14.9141C159.705 15.9812 160 17.1668 160 18.5304C160 19.8939 159.705 21.1388 159.175 22.1466C158.645 23.2137 157.878 24.0437 156.994 24.6365C156.111 25.2293 155.05 25.5257 153.93 25.5257C153.282 25.5257 152.634 25.4072 152.044 25.17C151.455 24.9329 150.925 24.6958 150.512 24.3401C150.099 23.9844 149.746 23.688 149.51 23.3323C149.274 22.9766 149.157 22.6802 149.157 22.443L149.923 22.0873V23.9251C149.923 24.3401 149.805 24.7551 149.51 24.9922C149.215 25.2886 148.862 25.4072 148.449 25.4072C148.037 25.4072 147.683 25.2886 147.389 24.9922C147.094 24.6958 146.976 24.3401 146.976 23.8658V8.21511C146.976 7.80013 147.094 7.38515 147.389 7.14801C147.683 6.8516 148.037 6.73303 148.449 6.73303C148.862 6.73303 149.215 6.8516 149.51 7.14801C149.805 7.44443 149.923 7.80013 149.923 8.21511V14.6177L149.51 14.3805C149.51 14.1434 149.628 13.9063 149.864 13.6099C150.099 13.3134 150.394 13.017 150.807 12.6613C151.219 12.3649 151.691 12.0685 152.221 11.8907C152.751 11.7128 153.341 11.5942 153.871 11.5942ZM153.518 14.3805C152.81 14.3805 152.162 14.5584 151.573 14.9141C151.042 15.2698 150.571 15.8033 150.276 16.3962C149.982 17.0483 149.805 17.7597 149.805 18.5304C149.805 19.301 149.982 20.0124 150.276 20.6645C150.571 21.3167 151.042 21.7909 151.573 22.2059C152.103 22.5616 152.751 22.7394 153.518 22.7394C154.225 22.7394 154.873 22.5616 155.403 22.2059C155.934 21.8502 156.346 21.3167 156.7 20.6645C156.994 20.0124 157.171 19.301 157.171 18.5304C157.171 17.7004 156.994 16.989 156.7 16.3962C156.405 15.7441 155.993 15.2698 155.403 14.9141C154.873 14.5584 154.284 14.3805 153.518 14.3805Z'
          fill='#1133BB'
        />
        <path
          d='M25.2228 20.0717L6.36465 15.5662C4.71456 15.1512 3.71272 13.4913 4.12524 11.8314L6.36465 2.34608C6.77717 0.686152 8.42726 -0.32166 10.0774 0.0933213L28.9356 4.59883C30.5856 5.01381 31.5875 6.67374 31.175 8.33366L28.9356 17.8189C28.523 19.4196 26.8729 20.4867 25.2228 20.0717Z'
          fill='#00C389'
        />
        <path
          d='M24.8103 22.9173L5.42173 22.9765C3.7127 22.9765 2.35727 21.613 2.35727 19.8938L2.29834 10.1714C2.29834 8.45221 3.65377 7.0887 5.3628 7.0887L24.7514 7.02942C26.4604 7.02942 27.8158 8.39293 27.8158 10.1121L27.8748 19.8345C27.8158 21.4945 26.4604 22.9173 24.8103 22.9173Z'
          fill='white'
        />
        <path
          d='M22.453 26H3.06446C1.35543 26 0 24.6365 0 22.9173V13.1356C0 11.4164 1.35543 10.0529 3.06446 10.0529H22.453C24.1621 10.0529 25.5175 11.4164 25.5175 13.1356V22.858C25.5175 24.5772 24.1621 26 22.453 26Z'
          fill='#1133BB'
        />
      </svg>
    );
  },
};
